import { useEffect, useMemo, useState } from 'react';
import { useReglages } from '../../api/reglages.jsx';
import { useDemande } from '../../components/Dialogue.jsx';
import { BoutonEnvoiServeur } from '../../components/BoutonEnvoiServeur.jsx';
import { CarteLienClient } from '../../components/CarteLienClient.jsx';
import { BonCommandeClient } from '../../components/BonCommandeClient.jsx';
import { EmailsOffre } from '../../components/EmailsOffre.jsx';
import { adresseDeFacturation, adressesDeLaFacture } from '../../lib/emails-offre';
import { MenuEnvoi } from '../../components/MenuEnvoi.jsx';
import { PiecesJointes } from '../../components/PiecesJointes.jsx';
import { ModifierClient } from '../../components/ModifierClient.jsx';
import { NouveauClient } from '../../components/NouveauClient.jsx';
import { estProvisoire, idCreePour, idDefinitif } from '../../lib/identifiants';
import { RelanceParLien } from '../../components/RelanceParLien.jsx';
import { Shell } from '../../components/layout/Shell.jsx';
import { QRCode } from '../../components/QRCode.jsx';
import { Bar } from '../../components/ui/Bar.jsx';
import { ACCESS_ROLE } from '../../lib/access';
import { Btn } from '../../components/ui/Btn.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { Inp, _inp, inpFS } from '../../components/ui/Inputs.jsx';
import { ChampDesignation } from '../../components/ui/ChampDesignation.jsx';
import { Pill } from '../../components/ui/Pill.jsx';
import { TexteReplie } from '../../components/ui/TexteReplie.jsx';
import { StatBox } from '../../components/ui/StatBox.jsx';
import { SOC } from '../../constants/company';
import { systemeQrUtilisable } from '../../constants/paiements-qr';
import { DEVIS_STYLES, FSTATUTS } from '../../constants/documents';
import { modelesProposes } from '../../constants/modeles';
import { metierUnites, metierCats } from '../../constants/trades';
import { CLE_MODELES } from '../modeles/ModelesPage.jsx';
import { ChoixTauxTva } from '../devis/ChampsConditions.jsx';
import { AcomptesFacture, acompteRecuDe } from './AcomptesFacture.jsx';
import { AjoutArticles } from '../devis/AjoutArticles.jsx';
import { LignesEditor } from '../devis/LignesEditor.jsx';
import { DocumentA4 } from '../documents/DocumentA4.jsx';
import { BoutonDocument } from '../../components/BoutonDocument.jsx';
import { ChampDescription } from '../../components/ChampDescription.jsx';
import { DEVISE, fmt } from '../../lib/currency';
import { estBloc } from '../../lib/blocs-lignes';
import { acompteEnAttente } from '../../lib/acompte-en-attente';
import {
  aEncaisser,
  avoirsSur,
  regleeParAvoir,
  soldeApresAvoirs,
  totalAEncaisser,
} from '../../lib/impayes';
import { tr, trf } from '../../lib/i18n';
import { MSG_BON_COMMANDE, manqueBonCommande } from '../../lib/bon-commande';
import { anneeDe, dateComptaPour, exercicesAcompte } from '../../lib/cloture';
import { echeancePour } from '../../lib/echeances';
import { TAUX_LEGAUX_ACTUELS, tauxTvaParDefaut } from '../../lib/tva';
import { dateEcheance, joursRetard } from '../../lib/dates';
import { remEff, remiseDuClient } from '../../lib/discounts';
import { prixApplique } from '../../lib/paliers';
import { printDoc } from '../../lib/print';
import { chantierDuDocument, libelleProjet } from '../../lib/projet';
import { swissQR } from '../../lib/swiss-qr';
import { docRef } from '../../lib/swiss-refs';
import { metEnAttente } from '../../lib/pieces-attente';
import { ceQuiManqueDocument, rangsSansTitre } from '../../lib/lignes-document';
import { envoisApi, piecesApi } from '../../api/resources';
import { adresseApi } from '../../api/client';
import { AnnexePhotos } from '../../rendu/AnnexePhotos.jsx';
import { photoDeLigne, photosAnnexe, photosFacture } from '../../lib/planche-photos';
import { mediaDeLigne } from '../../api/mappers';
import { peutEncaisser, voitLeBenefice } from '../../lib/access';
import { MargePiece } from '../../components/MargePiece.jsx';
import { ChoixClient } from '../../components/ChoixClient.jsx';
import { PaiementsRecus, usePaiements } from '../../components/PaiementsRecus.jsx';
import { MessagesFacture } from './MessagesFacture.jsx';
import {
  nextSeq,
  numeroDe,
  numeroPris,
  ordreDeSaisie,
  plusRecentesEnTete,
  today,
  uid,
} from '../../lib/utils';
import { auCentime, pourcentLisible, totauxDocument, ttcDocument } from '../../lib/vat';
import { avertissementIban } from '../../lib/iban-manquant';
import { C, DA, DOC_COULEURS } from '../../theme/palette';
import { composeMessage } from '../../lib/envoi';
import { MSG_SANS_TAMPON, tamponVoulu } from '../../lib/tampon';
import { ChampUnite } from '../../components/ui/ChampUnite.jsx';
import { DernierEnvoi } from '../../components/DernierEnvoi.jsx';
import { FacturesJointes } from '../../components/FacturesJointes.jsx';
import { EnvoiComptable } from './EnvoiComptable.jsx';
import { pasEncoreEnvoyee } from './envoi-facture';
import { CouleurMessage } from '../../components/CouleurMessage.jsx';
import { styleDuMessage } from '../../lib/styles-messages';

/** Délais de paiement proposés sur une facture. */
const DELAIS_PAIEMENT = ['15 jours', '30 jours', '45 jours', '60 jours', 'À réception'];

/** Avertissement quand le numéro d'une facture déjà envoyée change. */
const AVIS_NUMERO_FACTURE =
  'Le client a déjà reçu cette facture avec l’ancien numéro. Après le changement, renvoie-lui la facture : le QR de paiement change avec le numéro.';

const avisNumero = {
  fontSize: 10,
  color: '#9a3412',
  background: '#fff7ed',
  border: '1px solid #fdba74',
  borderRadius: 8,
  padding: '7px 9px',
  margin: '-4px 0 10px',
  lineHeight: 1.45,
};
export function FacturesPage({
  onNav,
  soc,
  factures,
  setFactures,
  rechargeFactures,
  devis,
  chantiers,
  clients,
  setClients,
  stock,
  catalogue,
  setCatalogue,
  setSoc,
  estMixte,
  univers,
  setUnivers,
  ouvrir,
  onOuvert,
}) {
  // « Bulletin de ma banque » (Réglages → Banque) que SwissTech ne peut pas
  // refaire : l'image remise par la banque remplace le QR-facture calculé.
  const bulletinBanque =
    soc?.paiement === 'bulletin' &&
    !(soc?.bulletinLu && systemeQrUtilisable(soc)) &&
    String(soc?.bulletinImage || '').startsWith('data:image/');
  // Lu, le bulletin reprend le titulaire tel que la banque l'a écrit.
  const luBanque = soc?.paiement === 'bulletin' && soc?.bulletinLu ? soc.bulletinLu : null;
  const demande = useDemande();
  const [menuEnvoi, setMenuEnvoi] = useState(false);
  const [plusFacture, setPlusFacture] = useState(false);
  // La facture échue relancée par WhatsApp : elle part comme l'envoi de la
  // facture, PDF joint, et non plus en une ligne de texte.
  const [relanceEnvoi, setRelanceEnvoi] = useState(null);
  // Relit le dernier envoi au journal après un envoi (e-mail, WhatsApp…).
  const [versionEnvoi, setVersionEnvoi] = useState(0);
  // Photos prises sur une facture neuve, déposées une fois la facture créée.
  const [photosBrouillon, setPhotosBrouillon] = useState([]);
  // Univers courant : magasin (vente) ou chantier (BTP).
  const estMag = estMixte ? univers === 'magasin' : soc?.secteur === 'magasin';
  const [view, setView] = useState('liste');
  // Le patron seul efface une pièce déjà émise ; le serveur le vérifie aussi.
  const estPatron = ACCESS_ROLE === 'patron';
  const [selId, setSelId] = useState(null);
  const [fQ, setFQ] = useState('');
  const [fFilt, setFFilt] = useState('tous');
  const [fYear, setFYear] = useState('tous');
  const [form, setForm] = useState(null);
  // Les modèles de l'offre servent aussi à la facture directe : toutes les
  // lignes d'un chantier type d'un coup, comme dans l'offre.
  const { reglageJson } = useReglages();
  // Au mix, l'univers choisi décide : le magasin propose ses modèles à lui.
  const modeles = modelesProposes(estMag ? 'magasin' : 'batiment', reglageJson(CLE_MODELES, []));
  const [voirModeles, setVoirModeles] = useState(false);
  const chargeModele = (m) => {
    setForm((p) => ({
      ...p,
      lignes: [...(p.lignes || []), ...(m.lignes || []).map((l) => ({ ...l, id: uid() }))],
    }));
    setVoirModeles(false);
  };
  const [editId, setEditId] = useState(null);
  const [addArtF, setAddArtF] = useState(false);
  const [openLineF, setOpenLineF] = useState(null);
  const [descLineF, setDescLineF] = useState(null);
  const [optOpenF, setOptOpenF] = useState(false);
  const [artQ, setArtQ] = useState('');
  const [rbShow, setRbShow] = useState(false);
  const [rbAmt, setRbAmt] = useState('');
  const [rbIban, setRbIban] = useState('');
  const [rbMotif, setRbMotif] = useState('Double paiement — facture réglée deux fois');
  const [rbPrint, setRbPrint] = useState(false);
  const [montrerRappel, setMontrerRappel] = useState(false);
  const [rappelFraisInput, setRappelFraisInput] = useState('');
  // Les frais de chaque niveau, réglés dans Réglages → Envois automatiques :
  // le rappel fait à la main les propose, le rappel automatique les applique.
  const [fraisRappel, setFraisRappel] = useState(null);
  useEffect(() => {
    Promise.resolve()
      .then(() => envoisApi.reglages())
      .then((r) => r && setFraisRappel(r))
      .catch(() => {});
  }, []);
  const [recurFreq, setRecurFreq] = useState('mensuel');
  const [style, setStyle] = useState(soc?.devisStyle || 'suisse');
  const [docCol, setDocCol] = useState(soc?.docCouleur || 'neutre');
  const [styleSaved, setStyleSaved] = useState(false);
  const sel = factures.find((f) => f.id === selId);
  // Un client créé sur place porte un identifiant provisoire jusqu'à ce que le
  // serveur l'enregistre ; la liste des clients prend alors le définitif, et
  // la facture le reprend — sans quoi la liste affichait un autre client.
  const clientDuFormulaire = form?.clientId;
  useEffect(() => {
    if (!estProvisoire(clientDuFormulaire)) return;
    const definitif = idDefinitif(clientDuFormulaire);
    if (definitif !== clientDuFormulaire) {
      setForm((p) => (p && p.clientId === clientDuFormulaire ? { ...p, clientId: definitif } : p));
    }
  }, [clients, clientDuFormulaire]);
  // Le client choisi dans la liste, ou créé sur place (à la main ou depuis les
  // contacts) : son délai de paiement et ses remises s'appliquent.
  const choisitClient = (cid, connu) => {
    const mag = estMixte ? univers === 'magasin' : soc?.secteur === 'magasin';
    const choisi = connu || (clients || []).find((c) => c.id === cid);
    setForm((p) => ({
      ...p,
      clientId: cid,
      echeance: choisi ? echeancePour(choisi, soc) : p.echeance,
      lignes: (p.lignes || []).map((l) =>
        l.ref && choisi ? { ...l, rem: remiseDuClient(choisi, l, mag) } : l,
      ),
    }));
  };
  // Photos de la facture ouverte en A4 : elles y paraissent en annexe, comme
  // dans le PDF que le client reçoit.
  const [piecesDoc, setPiecesDoc] = useState([]);
  // Les pièces se lisent aussi à la modification : les photos des articles se
  // rattachent à leur ligne, comme sur l'offre.
  const idDoc =
    view === 'doc' && Number.isInteger(sel?.id)
      ? sel.id
      : view === 'creer' && Number.isInteger(editId)
        ? editId
        : null;
  useEffect(() => {
    if (idDoc === null) return undefined;
    let actif = true;
    // Les pièces de la facture entière, puis les photos de ses articles.
    Promise.all([
      piecesApi.liste('FACTURE', idDoc),
      piecesApi.lignes('FACTURE', idDoc).catch(() => []),
    ])
      .then(
        ([pieces, desLignes]) => actif && setPiecesDoc([...(pieces || []), ...(desLignes || [])]),
      )
      .catch(() => actif && setPiecesDoc([]));
    return () => {
      actif = false;
    };
  }, [idDoc]);
  /** Photos et plans des articles de la facture, par clé de ligne. */
  const imgsParCle = useMemo(() => {
    const parCle = {};
    for (const pc of piecesDoc || []) {
      if (!pc || !pc.ligneCle) continue;
      (parCle[pc.ligneCle] = parCle[pc.ligneCle] || []).push(mediaDeLigne(pc));
    }
    return parCle;
  }, [piecesDoc]);
  // À la modification, chaque ligne retrouve ses photos, une fois lues.
  useEffect(() => {
    if (view !== 'creer' || !Object.keys(imgsParCle).length) return;
    setForm((f) =>
      f
        ? {
            ...f,
            lignes: (f.lignes || []).map((l) =>
              l.cle && imgsParCle[l.cle] && !(l.imgs || []).length
                ? { ...l, imgs: imgsParCle[l.cle] }
                : l,
            ),
          }
        : f,
    );
  }, [imgsParCle, view]);

  // Une case de l'accueil ouvre la liste déjà filtrée sur ce qu'elle compte.
  useEffect(() => {
    if (!ouvrir?.filtre) return;
    setFFilt(ouvrir.filtre);
    setSelId(null);
    setView('liste');
    if (onOuvert) onOuvert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ouvrir]);

  // « Convertir en facture » ouvre la facture créée, et non la liste.
  useEffect(() => {
    if (ouvrir?.factureId == null) return;
    if (!(factures || []).some((f) => f.id === ouvrir.factureId)) return;
    setSelId(ouvrir.factureId);
    setView('detail');
    if (onOuvert) onOuvert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ouvrir, factures]);

  // Une piece enregistree recoit son numero du serveur, et celui que l'ecran
  // lui avait donne ne designe plus rien. Sa reference, elle, ne change pas :
  // elle sert a la retrouver. Sans cela l'artisan etait renvoye a la liste a
  // l'instant meme ou il venait d'etablir sa facture.
  useEffect(() => {
    if (selId == null || sel || view === 'liste' || view === 'creer') {
      return;
    }
    // La facture créée d'abord : son numéro a pu changer en route, si un
    // collègue avait pris le même entre-temps.
    const creee = idCreePour(selId);
    if (creee != null && factures.some((f) => f.id === creee)) {
      setSelId(creee);
      return;
    }
    const memePiece = factures.find((f) => f.num != null && String(f.num) === String(selId));
    if (memePiece) {
      setSelId(memePiece.id);
      return;
    }
    setSelId(null);
    setView('liste');
  }, [selId, sel, view, factures]);
  // Les totaux sont ceux du document imprime : le hors taxe oubliait la remise
  // globale que la TVA, elle, retenait — et l'arrondi ne suivait pas celui du
  // serveur. La liste annoncait donc un montant que la facture ne portait pas.
  const calc = (f) => totauxDocument(f.lignes, f.tvaPct, f.remisePct);
  const nextNum = () => nextSeq(factures);
  const FREQ_MOIS = { mensuel: 1, bimestriel: 2, trimestriel: 3, semestriel: 6, annuel: 12 };
  const FREQ_LBL = {
    mensuel: 'Mensuel',
    bimestriel: 'Bimestriel',
    trimestriel: 'Trimestriel',
    semestriel: 'Semestriel',
    annuel: 'Annuel',
  };
  const addMois = (dstr, n) => {
    const m = (dstr || '').match(/(\d{1,2})\.(\d{1,2})\.(\d{4})/);
    const b = m ? new Date(+m[3], +m[2] - 1, +m[1]) : new Date();
    b.setMonth(b.getMonth() + (n || 1));
    return (
      String(b.getDate()).padStart(2, '0') +
      '.' +
      String(b.getMonth() + 1).padStart(2, '0') +
      '.' +
      b.getFullYear()
    );
  };
  const dateDue = (dstr) => {
    const m = (dstr || '').match(/(\d{1,2})\.(\d{1,2})\.(\d{4})/);
    if (!m) return false;
    const d = new Date(+m[3], +m[2] - 1, +m[1]);
    const t = new Date();
    t.setHours(0, 0, 0, 0);
    return d <= t;
  };
  const numFromList = (arr) => nextSeq(arr);
  const genererRecurs = (ids) => {
    setFactures((prev) => {
      let arr = prev.slice();
      const nouv = [];
      ids.forEach((id) => {
        const tpl = arr.find((f) => f.id === id);
        if (!tpl || !tpl.recur) return;
        const num = numFromList(arr.concat(nouv));
        nouv.push({
          ...tpl,
          id: num,
          num,
          statut: 'Brouillon',
          date: today(),
          recur: null,
          recurDe: tpl.id,
          paidAmount: 0,
          paidDate: null,
          rappelNiveau: 0,
        });
      });
      arr = arr.map((f) =>
        ids.includes(f.id) && f.recur
          ? {
              ...f,
              recur: {
                ...f.recur,
                prochaine: addMois(f.recur.prochaine, FREQ_MOIS[f.recur.freq] || 1),
              },
            }
          : f,
      );
      return nouv.concat(arr);
    });
  };

  // Le droit d'encaisser se regle par societe (Reglages → Acces) et le
  // serveur le fait respecter : sans lui, les boutons n'ont pas de sens.
  const encaisse = peutEncaisser();
  const { paiements, recharge: rechargePaiements } = usePaiements((factures || []).length);
  const marquerPayee = (f) =>
    setFactures((p) =>
      p.map((x) =>
        x.id === f.id
          ? { ...x, statut: 'Payée', paidDate: today(), paidAmount: ttcDocument(x) }
          : x,
      ),
    );
  /**
   * Défait un « Marquer payée » touché par erreur : la facture redevient
   * envoyée, sans montant perçu ni date de paiement.
   */
  const remettreNonPayee = (f) => {
    if (
      !window.confirm(
        trf(
          'Remettre la facture {0} en « non payée » ? Le paiement noté sera retiré.',
          f.num || f.id,
        ),
      )
    )
      return;
    setFactures((p) =>
      p.map((x) => (x.id === f.id ? { ...x, statut: 'Envoyée', paidDate: '', paidAmount: 0 } : x)),
    );
  };
  const blank = () => {
    setEditId(null);
    setForm({
      type: 'standard',
      chantierId: '',
      // Le client se choisit (recherche, derniers clients, tous les clients) :
      // en prendre un d'office faisait facturer le mauvais client.
      clientId: '',
      date: today(),
      // L'accord passe avec le client prime l'usage de la maison ; a defaut,
      // trente jours. Retaper le delai a chaque piece finit par produire
      // l'erreur qui fait relancer un client qui n'est pas en retard. Le
      // client choisi remet son propre delai.
      echeance: echeancePour(null, soc),
      tvaPct: tauxTvaParDefaut(soc),
      // En mode mixte, le document garde l'univers ou il a ete etabli :
      // sans cela une facture de magasin revenait en facture de chantier,
      // avec le vocabulaire et la mise en page de l'autre metier.
      sect: estMag ? 'magasin' : 'batiment',
      statut: 'Brouillon',
      intro: '',
      lignes: [],
    });
    setPhotosBrouillon([]);
    setView('creer');
  };
  // L'avoir annule tout ou partie d'une facture émise, sans l'effacer : il
  // reprend ses lignes, que l'on réduit si l'on n'en rend qu'une partie. Le
  // document se titre « Avoir », sans bulletin de versement.
  const startAvoir = (f) => {
    setEditId(null);
    setForm({
      type: 'avoir',
      chantierId: f.chantierId || '',
      siteId: f.siteId ?? null,
      clientId: f.clientId,
      date: today(),
      // Un avoir ne se paie pas : aucun délai de paiement.
      echeance: '',
      tvaPct: f.tvaPct,
      remisePct: f.remisePct ?? 0,
      sect: f.sect,
      desc: f.desc || '',
      commandeClient: f.commandeClient || '',
      emailsEnvoi: [...(f.emailsEnvoi || [])],
      mentions: trf('Avoir sur la facture n° {0} du {1}.', f.num || f.id, f.date || ''),
      // La facture créditée : soldée par l'avoir, elle ne se relance plus.
      avoirDe: typeof f.id === 'number' ? f.id : null,
      statut: 'Brouillon',
      intro: '',
      lignes: (f.lignes || []).map((l) => ({ ...l, id: uid() })),
    });
    setPhotosBrouillon([]);
    setView('creer');
  };
  const startEdit = (f) => {
    setEditId(f.id);
    setForm({ ...f, lignes: (f.lignes || []).map((l) => ({ id: uid(), ...l })) });
    setView('creer');
  };

  if (view === 'creer' && form) {
    const { ht, tva, ttc, remise } = totauxDocument(form.lignes, form.tvaPct, form.remisePct);
    // Le serveur exige une designation sur chaque ligne : une ligne libre
    // laissee sans titre faisait refuser l'enregistrement, et la facture
    // tout juste saisie disparaissait de la liste. Comme pour le devis, les
    // boutons restent actifs, grises, et disent ce qui manque.
    const ligneSansTitre = rangsSansTitre(form.lignes).length > 0;
    const incomplete = !form.clientId || form.lignes.length === 0 || ligneSansTitre;
    const tente = (statut) => {
      const manque = ceQuiManqueDocument(form);
      if (manque) {
        alert(manque);
        return;
      }
      // Une facture ne part pas sans le bon de commande que son client exige.
      if (
        statut === 'Envoyée' &&
        manqueBonCommande(
          form,
          (clients || []).find((c) => String(c.id) === String(form.clientId)),
        )
      ) {
        alert(tr(MSG_BON_COMMANDE));
        return;
      }
      save(statut);
    };
    const save = (statutVoulu) => {
      // L'acompte déjà reçu devient un paiement à sa date : il s'ajoute au
      // montant perçu, et le serveur l'inscrit dans l'année où il a été touché.
      const recuAcompte = acompteRecuDe(form, ttc);
      if (recuAcompte > 0 && !String(form.acompteRecuLe || '').trim()) {
        alert(tr('Indique la date à laquelle l’acompte a été reçu.'));
        return;
      }
      // Un paiement ne s'inscrit que sur une facture émise : l'acompte reçu
      // fait partir le brouillon comme envoyé.
      const statut = recuAcompte > 0 && statutVoulu === 'Brouillon' ? 'Envoyée' : statutVoulu;
      const avecAcompte =
        recuAcompte > 0
          ? {
              paidAmount: Math.min(ttc, (+form.paidAmount || 0) + recuAcompte),
              paidDate: String(form.acompteRecuLe).trim(),
              acompteRecu: 0,
              acompteRecuMontant: null,
              acompteRecuEnFrancs: false,
              acompteRecuLe: '',
            }
          : {};
      const lignesN = form.lignes.map((l) => ({
        ...l,
        q: +l.q || 0,
        p: +l.p || 0,
        rem: +l.rem || 0,
      }));
      // Le numéro peut être changé ; deux factures ne partagent jamais le même.
      const numVoulu = String(form.num ?? '').trim();
      if (numVoulu && numeroPris(factures, numVoulu, editId)) {
        alert(trf('Le numéro {0} est déjà utilisé par une autre facture.', numVoulu));
        return;
      }
      if (editId) {
        setFactures((p) =>
          p.map((x) =>
            x.id === editId
              ? { ...x, ...form, ...avecAcompte, lignes: lignesN, statut: statut || x.statut }
              : x,
          ),
        );
        setSelId(editId);
        setEditId(null);
        setView('detail');
        // « Enregistrer & envoyer » : la fenêtre d'envoi s'ouvre aussitôt.
        if (statut === 'Envoyée') setMenuEnvoi(true);
        return;
      }
      const num = numVoulu || nextNum();
      metEnAttente(num, photosBrouillon, 'FACTURE');
      setPhotosBrouillon([]);
      // Le stock du magasin baisse au serveur, à l'enregistrement de la
      // facture (brouillon compris) : l'écran ne le décompte plus lui-même.
      setFactures((p) => [
        {
          ...form,
          ...avecAcompte,
          id: num,
          num,
          lignes: lignesN,
          statut,
          // Réglages → Documents dit si le tampon se met d'office sur les factures.
          tampon: tamponVoulu(soc, 'facture') && !!(soc?.tampon || soc?.sigPatron),
        },
        ...p,
      ]);
      setSelId(num);
      setView('detail');
      if (statut === 'Envoyée') setMenuEnvoi(true);
    };
    return (
      <Shell
        active="factures"
        onNav={onNav}
        soc={soc}
        back
        onBack={() => {
          setEditId(null);
          setView('liste');
        }}
        pageTitle={
          editId
            ? '✎ Modifier la facture'
            : form.type === 'avoir'
              ? 'Nouvel avoir'
              : 'Nouvelle facture'
        }
        estMixte={estMixte}
        univers={univers}
        setUnivers={setUnivers}
      >
        <Card style={{ marginBottom: 11 }}>
          <Bar icon="🧾" title="Détails" color={C.navy} />
          <div style={{ padding: 13 }}>
            {/* Proposé tout seul, modifiable à tout moment, même une fois la
                facture envoyée : le patron décide, l'écran l'avertit. */}
            <Inp label={tr('Numéro')}>
              <input
                aria-label={tr('Numéro de la facture')}
                value={
                  form.num ?? (editId ? numeroDe(factures.find((x) => x.id === editId)) : nextNum())
                }
                onChange={(e) => setForm((p) => ({ ...p, num: e.target.value }))}
                style={_inp}
              />
            </Inp>
            {!!editId &&
              form.statut !== 'Brouillon' &&
              form.num != null &&
              form.num.trim() !== numeroDe(factures.find((x) => x.id === editId)) && (
                <div role="note" style={avisNumero}>
                  ⚠ {tr(AVIS_NUMERO_FACTURE)}
                </div>
              )}
            <Inp label="Client">
              <ChoixClient
                clients={clients}
                clientId={form.clientId}
                // Les dernières factures d'abord : la liste du serveur vient
                // de la plus ancienne à la plus récente.
                recents={[...(factures || [])]
                  .sort((x, y) => (+y.id || 0) - (+x.id || 0))
                  .map((f) => f.clientId)}
                onChoisir={(c) => choisitClient(c.id, c)}
                onChanger={() => setForm((p) => ({ ...p, clientId: '' }))}
              />
            </Inp>
            {form.clientId ? (
              <div style={{ margin: '-6px 0 9px' }}>
                <ModifierClient
                  key={form.clientId}
                  client={(clients || []).find((c) => String(c.id) === String(form.clientId))}
                  setClients={setClients}
                />
              </div>
            ) : (
              // Facture déjà envoyée (payée ou non) : « Nouveau client » et
              // « Depuis mes contacts » n'ont plus rien à faire ici.
              !(editId && form.statut !== 'Brouillon') && (
                <NouveauClient
                  clients={clients}
                  setClients={setClients}
                  onChoisi={(id) => choisitClient(id)}
                />
              )
            )}
            <BonCommandeClient
              value={form.commandeClient}
              onChange={(v) => setForm((p) => ({ ...p, commandeClient: v }))}
              client={(clients || []).find((c) => String(c.id) === String(form.clientId))}
              setClients={setClients}
            />
            {form.clientId && (
              <EmailsOffre
                value={form.emailsEnvoi}
                onChange={(v) => setForm((p) => ({ ...p, emailsEnvoi: v }))}
                client={(clients || []).find((c) => String(c.id) === String(form.clientId))}
                adresseFiche={adresseDeFacturation(
                  (clients || []).find((c) => String(c.id) === String(form.clientId)),
                )}
              />
            )}
            {/* La facture d'avancement se fait depuis le chantier, calculée sur
                l'offre : la saisie à la main a été retirée, à la demande du patron. */}
          </div>
        </Card>
        <Card style={{ marginBottom: 11 }}>
          <Bar icon="📋" title={'Lignes (' + form.lignes.length + ')'} color={C.navy} />
          <div style={{ padding: 13 }}>
            {editId && form.statut && form.statut !== 'Brouillon' && (
              <div
                role="note"
                style={{
                  background: C.amberL,
                  color: C.ink,
                  borderRadius: 10,
                  padding: '9px 12px',
                  fontSize: 10.5,
                  lineHeight: 1.4,
                  marginBottom: 9,
                }}
              >
                {tr(
                  '🔒 Facture déjà envoyée : ses articles ne changent plus (règle comptable). Pour en ajouter, fais une nouvelle facture.',
                )}
              </div>
            )}
            <LignesEditor
              piece="facture"
              devisId={Number.isInteger(editId) ? editId : undefined}
              form={form}
              setForm={setForm}
              catalogue={catalogue}
              setCatalogue={setCatalogue}
              stock={stock}
              clients={clients}
              estMag={estMixte ? univers === 'magasin' : soc?.secteur === 'magasin'}
              soc={soc}
              setSoc={setSoc}
            />
            <div
              style={{ background: C.navy, borderRadius: 9, padding: '10px 13px', marginTop: 10 }}
            >
              {[
                // Le total hors TVA avant la remise, la remise, puis le total remisé.
                ...(form.remisePct > 0
                  ? [
                      ['Total HT', ht + remise],
                      ['Remise ' + pourcentLisible(form.remisePct) + '%', -remise],
                    ]
                  : []),
                [form.remisePct > 0 ? 'Total HT après remise' : 'Sous-total HT', ht],
                [
                  totauxDocument(form.lignes, form.tvaPct, form.remisePct).multi
                    ? 'TVA (plusieurs taux)'
                    : 'TVA ' + (form.tvaPct ?? TAUX_LEGAUX_ACTUELS.normal) + '%',
                  tva,
                ],
              ].map(([l, v]) => (
                <div
                  key={l}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: 9,
                    color: 'rgba(255,255,255,.7)',
                    padding: '2px 0',
                  }}
                >
                  {/* Le taux du document se choisit ici : la maquette n'a pas de puces TVA. */}
                  {l === 'TVA ' + (form.tvaPct ?? TAUX_LEGAUX_ACTUELS.normal) + '%' ? (
                    <ChoixTauxTva
                      soc={soc}
                      date={form.date}
                      value={form.tvaPct ?? TAUX_LEGAUX_ACTUELS.normal}
                      onChange={(t) => setForm((p) => ({ ...p, tvaPct: t }))}
                    />
                  ) : (
                    <span>{l}</span>
                  )}
                  <span>
                    {v < 0 ? '− ' : ''}
                    {DEVISE} {fmt(Math.abs(v))}
                  </span>
                </div>
              ))}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: 6,
                  borderTop: '1px solid rgba(255,255,255,.2)',
                  marginTop: 4,
                }}
              >
                <span style={{ fontSize: 11, fontWeight: 800, color: '#fff' }}>Total TTC</span>
                <span style={{ fontSize: 15, fontWeight: 900, color: '#fff' }}>
                  {DEVISE} {fmt(ttc)}
                </span>
              </div>
            </div>
            {estMag && voitLeBenefice() && (
              <MargePiece
                lignes={form.lignes}
                stock={stock}
                remisePct={form.remisePct}
                tvaPct={form.tvaPct}
              />
            )}
          </div>
        </Card>
        {form.type !== 'avoir' && form.type !== 'acompte' && (
          <AcomptesFacture form={form} setForm={setForm} ttc={ttc} />
        )}
        {/* Comme l'offre : le client, les lignes, puis la date, le délai et
            les messages (repliés tant qu'ils sont vides). */}
        <Card style={{ marginBottom: 11 }}>
          <Bar icon="📝" title="Description & conditions" />
          <div style={{ padding: 13 }}>
            <Inp
              label="Date"
              value={form.date}
              onChange={(e) => setForm((p) => ({ ...p, date: e.target.value }))}
            />
            {/*
              La maquette tire l'echeance du client, sans la montrer ; la
              production la laisse corriger, en liste deroulante comme le client.
            */}
            {form.type !== 'avoir' && (
              <Inp label="Délai de paiement">
                <select
                  aria-label="Délai de paiement"
                  value={form.echeance || '30 jours'}
                  onChange={(e) => setForm((p) => ({ ...p, echeance: e.target.value }))}
                  style={{
                    width: '100%',
                    border: '1px solid ' + C.border,
                    borderRadius: 9,
                    padding: '10px 11px',
                    fontSize: 11,
                  }}
                >
                  {DELAIS_PAIEMENT.concat(
                    form.echeance && !DELAIS_PAIEMENT.includes(form.echeance)
                      ? [form.echeance]
                      : [],
                  ).map((d) => (
                    <option key={d} value={d}>
                      {d}
                    </option>
                  ))}
                </select>
              </Inp>
            )}
            <TexteReplie
              label="Message au client (s'affiche en haut de la facture)"
              rows={2}
              value={form.intro || ''}
              onChange={(e) => setForm((p) => ({ ...p, intro: e.target.value }))}
              styleTexte={styleDuMessage(form.stylesMessages, 'haut')}
              outil={
                <CouleurMessage
                  styles={form.stylesMessages}
                  quel="haut"
                  onChange={(v) => setForm((p) => ({ ...p, stylesMessages: v }))}
                />
              }
            />
            <TexteReplie
              label="Message en bas du document (sous vos coordonnées)"
              rows={2}
              placeholder="Ex. : Merci pour votre confiance. Garantie de 2 ans sur les travaux."
              value={form.piedMessage || ''}
              onChange={(e) => setForm((p) => ({ ...p, piedMessage: e.target.value }))}
              styleTexte={styleDuMessage(form.stylesMessages, 'bas')}
              outil={
                <CouleurMessage
                  styles={form.stylesMessages}
                  quel="bas"
                  onChange={(v) => setForm((p) => ({ ...p, stylesMessages: v }))}
                />
              }
            />
          </div>
        </Card>
        {modeles.length > 0 && (
          <Card style={{ marginBottom: 11 }}>
            <div style={{ padding: 13 }}>
              <div
                onClick={() => setVoirModeles((v) => !v)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 6,
                  background: '#f0fdf4',
                  border: '1px solid #16a34a55',
                  borderRadius: 9,
                  padding: 11,
                  cursor: 'pointer',
                  fontSize: 11,
                  fontWeight: 800,
                  color: '#166534',
                }}
              >
                📂 Charger un modèle ({modeles.length}){' '}
                <span style={{ fontSize: 9, opacity: 0.7 }}>{voirModeles ? '▲' : '▼'}</span>
              </div>
              {voirModeles && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
                  {modeles.map((m, i) => (
                    <span
                      key={i}
                      onClick={() => chargeModele(m)}
                      style={{
                        background: '#fff',
                        border: '1px solid #16a34a',
                        borderRadius: 8,
                        padding: '7px 11px',
                        fontSize: 11,
                        fontWeight: 700,
                        color: '#166534',
                        cursor: 'pointer',
                      }}
                    >
                      📦 {m.nom}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </Card>
        )}
        <Card style={{ marginBottom: 11 }}>
          <Bar
            icon="📷"
            title={editId ? 'Photos / matériel acheté' : 'Photos / pièces jointes'}
            color={C.purple}
            sub={
              editId
                ? 'Photo des travaux pour le client, ou facture du matériel acheté (pour toi)'
                : 'Justificatif, photo du produit ou des travaux (facultatif)'
            }
          />
          <div style={{ padding: 13 }}>
            {/*
              La piece part au serveur des le depot, et il lui faut donc une
              facture a laquelle s'accrocher : sur une facture neuve, les
              photos attendent sa creation (lib/pieces-attente.js). Une facture
              existante — même envoyée — reçoit ici aussi le matériel acheté :
              le patron le cherchait dans « Modifier la facture ».
            */}
            {Number.isInteger(editId) ? (
              <FacturesJointes
                genre="FACTURE"
                documentId={editId}
                numero={form.num ?? editId}
                categories={metierCats(soc, form.sect === 'magasin')}
                variante="fiche"
                magasin={form.sect === 'magasin' || estMag}
                montantHt={ht}
              />
            ) : (
              <PiecesJointes
                genre="FACTURE"
                documentId={editId}
                bouton={
                  estMag
                    ? '📷 Ajouter des photos (justificatif…)'
                    : '📷 Ajouter des photos (travaux, justificatif…)'
                }
                note
                plusieurs
                brouillons={photosBrouillon}
                onBrouillons={setPhotosBrouillon}
              />
            )}
          </div>
        </Card>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          {/* « D'abord enregistrer, et après, quand je veux, je l'envoie » :
              une nouvelle facture s'enregistre sans partir (brouillon) ;
              « Envoyer » sur la facture l'émet et l'envoie plus tard. */}
          <Btn
            label="💾 Enregistrer"
            ghost
            color={incomplete ? '#94A3B8' : C.navy}
            full
            onClick={() => tente(editId ? null : 'Brouillon')}
          />
          <Btn
            label={editId ? '✓ Enregistrer & envoyer' : '✓ Émettre & envoyer'}
            color={incomplete ? '#94A3B8' : C.green}
            full
            onClick={() => tente('Envoyée')}
          />
        </div>
        {(!form.clientId || form.lignes.length === 0) && (
          <div style={{ fontSize: 8, color: C.muted, textAlign: 'center', marginTop: 6 }}>
            Choisis un client et ajoute au moins une ligne.
          </div>
        )}
        {form.clientId && ligneSansTitre && (
          <div
            role="status"
            style={{ fontSize: 8, color: C.red, textAlign: 'center', marginTop: 6 }}
          >
            Donnez un titre à chaque ligne avant d’enregistrer.
          </div>
        )}
      </Shell>
    );
  }

  if (view === 'doc' && sel) {
    const cl = clients.find((c) => c.id === sel.clientId);
    const accent =
      docCol && docCol[0] === '#'
        ? docCol
        : DOC_COULEURS.find((c) => c.id === docCol)?.accent ||
          DEVIS_STYLES.find((s) => s.id === style)?.accent ||
          DA;
    const ov = sel.ov || {};
    const lieuAuto = (() => {
      const c = chantierDuDocument(sel, { chantiers, devis });
      return c ? [c.adr, c.npa].filter(Boolean).join(', ') : '';
    })();
    const cle = {
      ...(cl || {}),
      nom: ov.nom || cl?.nom || '',
      adr: ov.adr || cl?.adr || '',
      npa: ov.npa || cl?.npa || '',
    };
    return (
      <DocumentA4
        soc={soc}
        client={cle}
        onClose={() => setView('detail')}
        annexe={
          <AnnexePhotos
            photos={[
              ...photosFacture(piecesDoc, adresseApi),
              // Les photos des articles : la première est sur la ligne ; les
              // autres et les plans suivent en annexe.
              ...photosAnnexe(
                { lignes: (sel.lignes || []).map((l) => ({ ...l, imgs: imgsParCle[l.cle] })) },
                [],
                adresseApi,
                { dansLesLignes: true },
              ),
            ]}
            soc={soc}
            titre={'Facture ' + (sel.num || sel.id)}
            agrandit
          />
        }
        doc={{
          kind: 'facture',
          // Un avoir se titre « Avoir », sans bulletin de versement.
          type: sel.type,
          sect:
            sel.sect ||
            ((devis || []).find((d) => d.id === sel.devisId) || {}).sect ||
            (estMixte
              ? univers === 'magasin'
                ? 'magasin'
                : 'batiment'
              : soc?.secteur === 'magasin'
                ? 'magasin'
                : 'batiment'),
          intro: sel.intro,
          mentions: sel.mentions,
          piedMessage: sel.piedMessage,
          stylesMessages: sel.stylesMessages,
          // Payée : « Payé » et « Net à payer 0.00 », sans bulletin.
          paye: sel.statut === 'Payée',
          montantPaye: sel.paidAmount,
          noPay: sel.noPay,
          regie: sel.regie,
          tampon: sel.tampon,
          rappel: montrerRappel
            ? { niveau: sel.rappelNiveau || 1, frais: sel.rappelFrais || 0 }
            : null,
          accent,
          style,
          num: sel.num || sel.id,
          chantierId: sel.chantierId,
          // Le nom du chantier, ou la description du devis converti : la
          // facture d'un chantier sortait avec « Projet — ».
          projet: libelleProjet(
            { chantierId: sel.chantierId, siteId: sel.siteId, devisId: sel.devisId },
            { chantiers, devis },
          ),
          refOv: ov.ref,
          // La facture d'acompte d'une offre porte la reference du QR de
          // l'offre : un acompte verse avec ce QR se rapproche d'elle.
          refId: sel.identifiantReference,
          // Le vehicule repris de l'offre de garage, comme sur le devis.
          plaque: sel.plaque,
          vehicule: sel.vehicule,
          commandeClient: sel.commandeClient,
          chLieu: ov.lieu || lieuAuto,
          date: sel.date,
          ech: sel.echeance,
          objet: sel.desc,
          lignes: (sel.lignes || [])
            .filter((l) => (l.d || '').trim() !== '' || (+l.p || 0) !== 0)
            .map((l) => ({
              photo: photoDeLigne({ imgs: imgsParCle[l.cle] }),
              d: l.d,
              sd: l.sd,
              hl: l.hl,
              q: l.q,
              u: l.u,
              p: l.p,
              rem: remEff(l),
              tva: l.tva,
              paliers: l.paliers,
            })),
          // La remise de la facture : sans elle, la feuille annonçait un total
          // plus haut que celui de son QR-facture.
          remisePct: sel.remisePct || 0,
          tvaPct: sel.tvaPct ?? TAUX_LEGAUX_ACTUELS.normal,
          acomptePct: 0,
          // L'acompte demandé sur la facture : le QR le porte avant le solde.
          acompteDemande: sel.acompteDemande || 0,
          acompteDemandeMontant: sel.acompteDemandeMontant || null,
          recu: montrerRappel ? sel.paidAmount || 0 : 0,
        }}
      />
    );
  }

  if (view === 'detail' && sel) {
    const cl = clients.find((c) => c.id === sel.clientId);
    // Le numéro se change par le crayon à côté du numéro, la facture envoyée
    // ou payée.
    const changeNumero = async () => {
      const v = await demande(
        'Numéro de la facture (laisser vide = numéro automatique) :',
        sel.num || sel.id,
      );
      if (v !== null) {
        const t = v.trim();
        if (t && numeroPris(factures, t, sel.id)) {
          alert(trf('Le numéro {0} est déjà utilisé par une autre facture.', t));
          return;
        }
        // Envoyée, la facture est chez le client : il faudra la lui renvoyer.
        if (
          t !== (sel.num || String(sel.id)) &&
          sel.statut !== 'Brouillon' &&
          !window.confirm(tr(AVIS_NUMERO_FACTURE))
        ) {
          return;
        }
        setFactures((p) =>
          p.map((x) => (x.id === sel.id ? { ...x, num: t && t !== sel.id ? t : undefined } : x)),
        );
      }
    };
    const { ht, tva, ttc, remise } = calc(sel);
    // Ce que les avoirs émis sur la facture rendent déjà au client : le
    // reste dû, les rappels et les paiements le retranchent.
    const creditAvoirs = avoirsSur(sel, factures).reduce((s, a) => s + ttcDocument(a), 0);
    const soldeeParAvoir = regleeParAvoir(sel, factures);
    const aEnvoyer = pasEncoreEnvoyee(sel);
    const col = aEnvoyer ? C.purple : FSTATUTS[sel.statut] || C.muted;
    const lieuAuto = (() => {
      const c = chantierDuDocument(sel, { chantiers, devis });
      return c ? [c.adr, c.npa].filter(Boolean).join(', ') : '';
    })();
    return (
      <Shell
        active="factures"
        onNav={onNav}
        soc={soc}
        back
        onBack={() => setView('liste')}
        pageTitle={sel.num || sel.id}
        estMixte={estMixte}
        univers={univers}
        setUnivers={setUnivers}
      >
        <Card style={{ marginBottom: 11 }}>
          <div
            style={{ background: C.white, padding: '12px 14px', borderBottom: '3px solid ' + DA }}
          >
            <div
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}
            >
              <div></div>
              <div style={{ textAlign: 'right' }}>
                <div
                  style={{
                    background: DA,
                    color: '#fff',
                    fontSize: 8,
                    fontWeight: 700,
                    padding: '2px 8px',
                    borderRadius: 5,
                    display: 'inline-block',
                  }}
                >
                  {sel.type === 'avoir' ? 'AVOIR' : 'FACTURE'}
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    gap: 6,
                  }}
                >
                  <div style={{ fontSize: 13, fontWeight: 900 }}>{sel.num || sel.id}</div>
                  <button
                    onClick={changeNumero}
                    style={{
                      background: C.navyXL,
                      border: 'none',
                      borderRadius: 6,
                      padding: '3px 7px',
                      fontSize: 9,
                      fontWeight: 700,
                      color: C.navy,
                      cursor: 'pointer',
                    }}
                  >
                    ✏️
                  </button>
                </div>
                <div style={{ marginTop: 4 }}>
                  <Pill label={aEnvoyer ? '✏️ à envoyer' : sel.statut} color={col} size={8} />
                </div>
                {/* Comme dans la liste : ouverte, la facture échue ne disait
                    pas qu'elle était en retard. */}
                {aEncaisser(sel, devis, factures) && joursRetard(sel) > 0 && (
                  <div style={{ fontSize: 8, color: C.red, fontWeight: 700, marginTop: 3 }}>
                    ⚠ en retard de {joursRetard(sel)} j
                  </div>
                )}
                <MentionAvoir f={sel} factures={factures} />
              </div>
            </div>
          </div>
          {cl && (
            <div
              style={{
                margin: '10px 14px',
                background: C.navyXL,
                borderRadius: 8,
                padding: '9px 11px',
              }}
            >
              <div style={{ fontSize: 7.5, color: C.muted, textTransform: 'uppercase' }}>
                Facturé à
              </div>
              <div style={{ fontSize: 11, fontWeight: 700 }}>{cl.nom}</div>
              <div style={{ fontSize: 8.5, color: C.grey }}>
                {cl.adr} · {cl.npa}
              </div>
              {String(sel.commandeClient ?? '').trim() && (
                <div style={{ fontSize: 10, color: C.ink, marginTop: 5 }}>
                  🧾 {tr('Votre bon de commande :')} <b>{sel.commandeClient}</b>
                </div>
              )}
            </div>
          )}
          {/* Le paiement (QR ou non) se règle une fois dans Réglages → Documents,
              et la copie d'une facture a été retirée de la fiche : le patron
              ne voyait pas à quoi servaient ces deux boutons ici. */}
          <div style={{ padding: '0 14px 14px' }}>
            {(sel.lignes || []).map((l, rangL) => {
              const _op = openLineF === l.id;
              const _dc = descLineF === l.id;
              const _lg = (l.sd || '').length > 70;
              const _u = (k, v) =>
                setFactures((p) =>
                  p.map((f) =>
                    f.id === sel.id
                      ? {
                          ...f,
                          lignes: f.lignes.map((x) => (x.id === l.id ? { ...x, [k]: v } : x)),
                        }
                      : f,
                  ),
                );
              return (
                <div
                  key={l.id}
                  style={{
                    background: C.white,
                    border: '1px solid ' + C.border,
                    borderRadius: 13,
                    padding: '12px 13px',
                    marginBottom: 9,
                    boxShadow: '0 1px 3px rgba(15,22,38,.05)',
                  }}
                >
                  <div
                    onClick={() => setOpenLineF(_op ? null : l.id)}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 10,
                      cursor: 'pointer',
                    }}
                  >
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{ fontSize: 12.5, fontWeight: 800, color: C.ink, lineHeight: 1.3 }}
                      >
                        {l.d || '(article)'}
                      </div>
                      {l.sd && (
                        <div
                          style={{
                            fontSize: 10.5,
                            color: C.ink,
                            lineHeight: 1.45,
                            marginTop: 3,
                            // Les retours à la ligne comptent : le détail d'un bloc, un par ligne.
                            whiteSpace: 'pre-wrap',
                            ...(!_dc && _lg ? { maxHeight: 31, overflow: 'hidden' } : {}),
                          }}
                        >
                          {l.sd}
                        </div>
                      )}
                      {_lg && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            setDescLineF(_dc ? null : l.id);
                          }}
                          style={{
                            fontSize: 10,
                            fontWeight: 700,
                            color: C.navy,
                            cursor: 'pointer',
                            marginTop: 2,
                            display: 'inline-block',
                          }}
                        >
                          {_dc ? 'Réduire ▲' : 'Plus… ▼'}
                        </span>
                      )}
                    </div>
                    <div style={{ color: C.muted, fontSize: 13, marginTop: 2 }}>
                      {_op ? '▲' : '✎'}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: 9,
                      paddingTop: 9,
                      borderTop: '1px dashed ' + C.border,
                    }}
                  >
                    <div style={{ fontSize: 11, color: C.grey, fontWeight: 600 }}>
                      {estBloc(l)
                        ? tr('Prix global')
                        : l.q + ' × ' + DEVISE + ' ' + fmt(prixApplique(l)) + ' / ' + (l.u || 'u')}
                      {(+l.rem || 0) > 0 ? ' · -' + l.rem + '%' : ''}
                    </div>
                    <div style={{ fontSize: 14, fontWeight: 900, color: C.ink }}>
                      {DEVISE} {fmt((+l.q || 0) * prixApplique(l) * (1 - (+l.rem || 0) / 100))}
                    </div>
                  </div>
                  {_op && (
                    <div
                      style={{ marginTop: 10, borderTop: '1px dashed ' + C.border, paddingTop: 10 }}
                    >
                      {/* Bâtiment : d'abord de quoi il s'agit (« Plafond, salle de
                          bain »), puis ce qu'on y fait (« Préparation du plafond,
                          masticage, ponçage, prêt à peindre »). */}
                      <ChampDesignation
                        value={l.d}
                        rang={rangL + 1}
                        onChange={(v) => _u('d', v)}
                        label={estMag ? 'Désignation' : 'Désignation — de quoi il s’agit'}
                        placeholder={estMag ? undefined : tr('ex. Plafond, salle de bain')}
                      />
                      <Inp label={estMag ? 'Description' : 'Description — ce qu’on fait'}>
                        <ChampDescription
                          value={l.sd || ''}
                          onChange={(v) => _u('sd', v)}
                          placeholder={
                            estMag
                              ? 'Détails (optionnel)'
                              : tr('ex. Préparation du plafond, masticage, ponçage, prêt à peindre')
                          }
                        />
                      </Inp>
                      <div style={{ display: 'flex', gap: 7 }}>
                        <div style={{ flex: 1 }}>
                          <Inp
                            label="Quantité"
                            type="text"
                            value={l.q}
                            onChange={(e) => _u('q', e.target.value.replace(',', '.'))}
                          />
                        </div>
                        <div style={{ flex: 1 }}>
                          <ChampUnite
                            value={l.u}
                            onChange={(u) => _u('u', u)}
                            unites={metierUnites(soc, estMag)}
                            placeholder={estMag ? 'pièce, bouteille, pack…' : 'm², pce, h…'}
                          />
                        </div>
                        <div style={{ flex: 1 }}>
                          <Inp
                            label={'Prix ' + DEVISE}
                            type="text"
                            value={l.p}
                            onChange={(e) => _u('p', e.target.value.replace(',', '.'))}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginTop: 2,
                        }}
                      >
                        <button
                          onClick={() => {
                            setFactures((p) =>
                              p.map((f) =>
                                f.id === sel.id
                                  ? { ...f, lignes: f.lignes.filter((x) => x.id !== l.id) }
                                  : f,
                              ),
                            );
                            setOpenLineF(null);
                          }}
                          style={{
                            background: C.redL,
                            border: 'none',
                            borderRadius: 8,
                            color: C.red,
                            padding: '8px 12px',
                            fontSize: 11,
                            fontWeight: 700,
                            cursor: 'pointer',
                          }}
                        >
                          🗑 Supprimer
                        </button>
                        <button
                          onClick={() => setOpenLineF(null)}
                          style={{
                            background: C.navy,
                            border: 'none',
                            borderRadius: 8,
                            color: '#fff',
                            padding: '8px 16px',
                            fontSize: 11,
                            fontWeight: 800,
                            cursor: 'pointer',
                          }}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            <div style={{ marginTop: 10, paddingTop: 10, borderTop: '2px solid ' + C.border }}>
              {[
                // Le total hors TVA avant la remise, la remise, puis le total remisé.
                ...(sel.remisePct > 0
                  ? [
                      ['Total HT', ht + remise],
                      ['Remise ' + pourcentLisible(sel.remisePct) + '%', -remise],
                    ]
                  : []),
                [sel.remisePct > 0 ? 'Total HT après remise' : 'Sous-total HT', ht],
                [
                  totauxDocument(sel.lignes, sel.tvaPct, sel.remisePct).multi
                    ? 'TVA (plusieurs taux)'
                    : 'TVA ' + (sel.tvaPct ?? TAUX_LEGAUX_ACTUELS.normal) + '%',
                  tva,
                ],
              ].map(([l, v]) => (
                <div
                  key={l}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '3px 0',
                    fontSize: 9.5,
                    color: C.grey,
                  }}
                >
                  <span>{l}</span>
                  <span>
                    {v < 0 ? '− ' : ''}
                    {DEVISE} {fmt(Math.abs(v))}
                  </span>
                </div>
              ))}
              <div
                style={{
                  background: DA,
                  borderRadius: 8,
                  padding: '9px 12px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: 6,
                }}
              >
                <span style={{ fontSize: 11, fontWeight: 800, color: '#fff' }}>Total TTC</span>
                <span style={{ fontSize: 15, fontWeight: 900, color: '#fff' }}>
                  {DEVISE} {fmt(ttc)}
                </span>
              </div>
            </div>
          </div>
          <div style={{ padding: '0 14px 14px' }}>
            {/*
              Les photos partent au serveur des le depot et ne voyagent pas
              avec la facture : elles vivaient jusqu'ici dans l'etat de
              l'ecran, et les perdre revenait a ne les avoir jamais prises.
            */}
            {/* Un seul bouton « Joindre » : photo pour le client (dans le PDF)
                ou matériel acheté, que le client ne voit pas et qui donne la
                marge de la facture. */}
            <div style={{ fontSize: 8, fontWeight: 800, color: C.muted, marginBottom: 6 }}>
              {tr('📎 PIÈCES JOINTES')}
            </div>
            <FacturesJointes
              genre="FACTURE"
              documentId={sel.id}
              numero={sel.num ?? sel.id}
              categories={metierCats(soc, sel.sect === 'magasin')}
              variante="fiche"
              magasin={sel.sect === 'magasin' || estMag}
              montantHt={ht}
            />
          </div>
        </Card>
        {/* Un avoir rend de l'argent au client : pas de bulletin. */}
        {sel.type === 'avoir' ? null : bulletinBanque ? (
          <Card style={{ marginBottom: 11 }}>
            <Bar
              icon="📎"
              title="Bulletin de ma banque"
              color={C.navy}
              sub="Imprimé tel quel au bas de la facture"
            />
            <div style={{ padding: 13 }}>
              <img
                src={soc.bulletinImage}
                alt="Bulletin de ma banque"
                style={{ width: '100%', display: 'block', borderRadius: 6 }}
              />
            </div>
          </Card>
        ) : (
          <Card style={{ marginBottom: 11 }}>
            <Bar
              icon="🇨🇭"
              title="QR-facture — Bulletin de versement"
              color={C.navy}
              sub="Norme SIX"
            />
            <div style={{ padding: 13, display: 'flex', gap: 14, alignItems: 'flex-start' }}>
              <div style={{ background: C.navyXL, borderRadius: 10, padding: 8, flexShrink: 0 }}>
                <QRCode
                  size={84}
                  color={C.ink}
                  value={swissQR({
                    iban: soc?.iban || SOC.iban,
                    nom: luBanque?.nom || soc?.nom || SOC.nom,
                    adr: luBanque?.adresse || soc?.adr || SOC.adr,
                    npa: luBanque?.npa || soc?.npa || SOC.npa,
                    amount: ttc,
                    clientNom: sel.ov?.nom || cl?.nom,
                    clientAdr: sel.ov?.adr || cl?.adr,
                    clientNpa: sel.ov?.npa || cl?.npa,
                    refType: docRef(numeroDe(sel), soc?.iban || SOC.iban).type,
                    ref:
                      (sel.ov?.ref && sel.ov.ref.trim()) ||
                      docRef(numeroDe(sel), soc?.iban || SOC.iban).ref,
                    msg: 'Facture ' + numeroDe(sel),
                  })}
                />
              </div>
              <div style={{ flex: 1 }}>
                {[
                  ['Créancier', luBanque?.nom || soc?.nom || SOC.nom],
                  ['IBAN', soc?.iban || SOC.iban],
                  ['Montant', DEVISE + ' ' + fmt(ttc)],
                  [
                    docRef(numeroDe(sel), soc?.iban || SOC.iban).nom,
                    docRef(numeroDe(sel), soc?.iban || SOC.iban).aff,
                  ],
                ].map(([l, v]) => (
                  <div key={l} style={{ fontSize: 9, marginBottom: 3 }}>
                    <span style={{ color: C.muted }}>{l} : </span>
                    <b>{v}</b>
                  </div>
                ))}
              </div>
            </div>
          </Card>
        )}

        {/* Un avoir rend de l'argent : ce n'est pas une vente, pas de bénéfice. */}
        {estMag && voitLeBenefice() && sel.type !== 'avoir' && (
          <div style={{ marginBottom: 8 }}>
            <MargePiece
              lignes={sel.lignes}
              stock={stock}
              remisePct={sel.remisePct}
              tvaPct={sel.tvaPct}
            />
          </div>
        )}
        {sel.statut === 'Brouillon' && (
          <div style={{ marginBottom: 8 }}>
            <AjoutArticles
              catalogue={catalogue}
              setCatalogue={setCatalogue}
              stock={stock}
              soc={soc}
              estMag={estMixte ? univers === 'magasin' : soc?.secteur === 'magasin'}
              client={clients.find((c) => c.id === sel.clientId)}
              libelleAjout="➕ Ajouter cette ligne à la facture"
              onAjout={(ligne) =>
                setFactures((p) =>
                  p.map((f) =>
                    f.id === sel.id ? { ...f, lignes: [...(f.lignes || []), ligne] } : f,
                  ),
                )
              }
            />
          </div>
        )}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: 8,
            marginBottom: 8,
          }}
        >
          {manqueBonCommande(sel, cl) && sel.statut !== 'Payée' && (
            <div
              role="alert"
              style={{
                background: C.redL,
                color: C.red,
                borderRadius: 9,
                padding: '9px 11px',
                fontSize: 11,
                fontWeight: 700,
                lineHeight: 1.45,
              }}
            >
              ⚠ {tr(MSG_BON_COMMANDE)}
            </div>
          )}
          {/*
            L'envoi n'est plus reserve au brouillon : une facture s'egare, se
            renvoie, s'accompagne d'un rappel. Le statut passe a « Envoyee » au
            premier envoi et ne bouge plus ensuite.
          */}
          {/* Le brouillon se termine d'abord : « Modifier » reste en vue. */}
          {sel.statut === 'Brouillon' && (
            <Btn label="✎ Modifier la facture" color={C.navy} full onClick={() => startEdit(sel)} />
          )}
          <Btn
            label="📤 Envoyer"
            color={C.teal}
            full
            onClick={() => {
              // Sans le bon de commande que le client exige, la facture ne
              // serait pas payée : elle se complète d'abord.
              if (manqueBonCommande(sel, cl)) {
                alert(tr(MSG_BON_COMMANDE));
                startEdit(sel);
                return;
              }
              setMenuEnvoi(true);
            }}
          />
          {encaisse &&
            sel.type !== 'avoir' &&
            !soldeeParAvoir &&
            (sel.statut === 'Envoyée' || sel.statut === 'Partielle') && (
              <Btn label="✓ Marquer payée" color={C.green} full onClick={() => marquerPayee(sel)} />
            )}
          {encaisse && sel.statut === 'Payée' && (
            <Btn
              label="↩️ Remettre non payée"
              ghost
              color={C.amber}
              full
              onClick={() => remettreNonPayee(sel)}
            />
          )}
          {/* Le vrai PDF, celui que le client reçoit : un aperçu tant que la
              facture est un brouillon, le document officiel une fois envoyée. */}
          {Number.isInteger(sel.id) ? (
            <BoutonDocument
              chemin={
                sel.statut === 'Brouillon'
                  ? `/factures/${sel.id}/document/apercu`
                  : `/factures/${sel.id}/document`
              }
              label={sel.type === 'avoir' ? '📄 PDF de l’avoir' : '📄 PDF de la facture'}
              color={DEVIS_STYLES.find((s) => s.id === style)?.accent || DA}
              full
            />
          ) : (
            <Btn
              label="📄 Document A4"
              color={DEVIS_STYLES.find((s) => s.id === style)?.accent || DA}
              full
              onClick={() => {
                setMontrerRappel(false);
                setView('doc');
              }}
            />
          )}
          {/* Comme sur l'offre : envoyer et encaisser d'abord ; modifier et le
              tampon sont rangés sous « ⋯ Plus ». */}
          <button
            type="button"
            aria-expanded={plusFacture}
            onClick={() => setPlusFacture((o) => !o)}
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              gap: 6,
              padding: '10px 0',
              borderRadius: 11,
              border: '1px solid ' + C.border,
              background: C.white,
              color: C.navy,
              fontSize: 11.5,
              fontWeight: 800,
              cursor: 'pointer',
            }}
          >
            <span aria-hidden="true">⋯</span>
            <span>{tr('Plus')}</span>
            <span aria-hidden="true">{plusFacture ? '▴' : '▾'}</span>
          </button>
          {plusFacture && (
            <>
              {sel.statut === 'Brouillon' ? null : sel.statut !== 'Payée' ? (
                <Btn
                  label="✎ Modifier la facture"
                  color={C.navy}
                  full
                  onClick={() => startEdit(sel)}
                />
              ) : (
                <MessagesFacture
                  key={sel.id}
                  facture={sel}
                  onEnregistre={(m) =>
                    setFactures((p) => p.map((x) => (x.id === sel.id ? { ...x, ...m } : x)))
                  }
                />
              )}
              <div
                onClick={() => {
                  // Sans tampon ni signature réglés, l'interrupteur s'allumait et
                  // rien ne paraissait sur le PDF : il dit où les ajouter.
                  if (!sel.tampon && !(soc?.tampon || soc?.sigPatron)) {
                    alert(tr(MSG_SANS_TAMPON));
                    return;
                  }
                  setFactures((p) =>
                    p.map((x) => (x.id === sel.id ? { ...x, tampon: !x.tampon } : x)),
                  );
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 9,
                  background: sel.tampon ? C.purple + '14' : C.navyXL,
                  border: '1px solid ' + (sel.tampon ? C.purple : C.border),
                  borderRadius: 11,
                  padding: '10px 12px',
                  cursor: 'pointer',
                  marginBottom: 8,
                }}
              >
                <span style={{ fontSize: 17 }}>🔖</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 10.5, fontWeight: 800, color: C.ink }}>
                    Apposer le tampon + ma signature
                  </div>
                  <div style={{ fontSize: 8, color: C.muted }}>
                    Ajoute ton tampon et ta signature en bas de la facture.
                  </div>
                </div>
                <div
                  style={{
                    width: 40,
                    height: 23,
                    borderRadius: 99,
                    background: sel.tampon ? C.green : C.border,
                    position: 'relative',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      top: 2.5,
                      left: sel.tampon ? 19 : 2.5,
                      width: 18,
                      height: 18,
                      borderRadius: 99,
                      background: '#fff',
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </div>
        {/*
          Un acompte encaisse en decembre pour des travaux du printemps suivant
          pose une question que l'application ne peut pas trancher seule : la
          methode des recettes le compte l'annee de l'encaissement, la methode
          d'engagement l'annee des travaux. Les deux sont admises en Suisse.
        */}
        {/* Une fois l'argent reçu seulement : sur un brouillon ou une
            facture impayée, « encaissé en … » était faux. */}
        {sel.type === 'acompte' &&
          (sel.statut === 'Payée' || sel.statut === 'Partielle') &&
          // Les travaux déjà facturés la même année : il n'y a rien à choisir
          // (la carte proposait toujours l'année suivante).
          !(
            !sel.dateCompta &&
            sel.devisId != null &&
            factures.some(
              (x) =>
                x.id !== sel.id &&
                x.devisId === sel.devisId &&
                x.type !== 'acompte' &&
                x.type !== 'avoir' &&
                x.statut !== 'Brouillon' &&
                x.statut !== 'Annulée' &&
                anneeDe({ date: x.date }) === anneeDe({ date: sel.date }),
            )
          ) &&
          (() => {
            const { encaisse, travaux, retenu } = exercicesAcompte(sel);
            return (
              <Card style={{ marginBottom: 8 }}>
                <Bar icon="📅" title="Année de comptabilisation (CA)" color={C.navy} />
                <div style={{ padding: 13 }}>
                  <div style={{ fontSize: 9.5, color: C.muted, marginBottom: 9, lineHeight: 1.5 }}>
                    Cet acompte a été encaissé en {encaisse}. Choisis dans quel exercice il compte
                    dans ton chiffre d’affaires : l’année encaissée (méthode des recettes) ou
                    l’année des travaux (méthode d’engagement — produit reçu d’avance).
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    {[encaisse, travaux].map((an) => (
                      <span
                        key={an}
                        onClick={() =>
                          setFactures((p) =>
                            p.map((x) =>
                              x.id === sel.id
                                ? { ...x, dateCompta: dateComptaPour(an, encaisse) }
                                : x,
                            ),
                          )
                        }
                        style={{
                          flex: 1,
                          textAlign: 'center',
                          padding: '11px 8px',
                          borderRadius: 9,
                          fontSize: 12.5,
                          fontWeight: 800,
                          cursor: 'pointer',
                          background: retenu === an ? C.navy : '#fff',
                          color: retenu === an ? '#fff' : C.ink,
                          border: '1px solid ' + (retenu === an ? C.navy : C.border),
                        }}
                      >
                        {an}
                        <div style={{ fontSize: 7.5, fontWeight: 600, opacity: 0.8 }}>
                          {an === encaisse ? 'encaissé' : 'travaux'}
                        </div>
                      </span>
                    ))}
                  </div>
                </div>
              </Card>
            );
          })()}
        {menuEnvoi && (
          <MenuEnvoi
            piece={sel}
            nature={sel.type === 'avoir' ? 'Avoir' : 'Facture'}
            client={cl}
            soc={soc}
            onClose={() => setMenuEnvoi(false)}
            notePartage={{ type: 'FACTURE', id: sel.id }}
            // Un brouillon n'a pas encore de lien pour le client (le serveur
            // le refusait) : il en reçoit un une fois émis.
            lienType={sel.statut !== 'Brouillon' ? 'facture' : undefined}
            pdfALaDemande
            cheminPdf={
              Number.isInteger(sel.id) && sel.statut !== 'Brouillon'
                ? `/factures/${sel.id}/document`
                : undefined
            }
            // Le serveur n'envoie qu'une facture qu'il connait et qu'il peut
            // figer : un brouillon ou une piece pas encore enregistree part par
            // la messagerie de l'appareil, comme avant.
            envoiServeur={
              Number.isInteger(sel.id) && sel.statut !== 'Brouillon'
                ? () => envoisApi.envoieFacture(sel.id)
                : null
            }
            cibleServeur={adressesDeLaFacture(cl, sel.emailsEnvoi).join(', ')}
            avertissement={avertissementIban({
              soc,
              piece: sel,
              montant: calc(sel).ttc,
              quoi: 'la facture',
              onNav,
            })}
            serveurIndisponible={
              !Number.isInteger(sel.id)
                ? 'Enregistre la facture pour que SwissTech puisse l’envoyer avec son PDF.'
                : sel.statut === 'Brouillon'
                  ? 'Émets la facture pour que SwissTech puisse l’envoyer avec son PDF.'
                  : ''
            }
            emettre={
              Number.isInteger(sel.id) && sel.statut === 'Brouillon'
                ? {
                    label: '✓ Émettre la facture',
                    onClick: () =>
                      setFactures((p) =>
                        p.map((x) => (x.id === sel.id ? { ...x, statut: 'Envoyée' } : x)),
                      ),
                  }
                : undefined
            }
            onEnvoye={() => {
              setTimeout(() => setVersionEnvoi((v) => v + 1), 800);
              setFactures((p) =>
                p.map((x) =>
                  x.id === sel.id
                    ? {
                        // `envoye` se deduit desormais de la date, qui est ce
                        // que le serveur conserve : deux verites pour un seul
                        // fait finissent par se contredire.
                        ...x,
                        envoyeLe: today(),
                        statut: x.statut === 'Brouillon' ? 'Envoyée' : x.statut,
                      }
                    : x,
                ),
              );
            }}
          />
        )}
        {sel.vuLe ? (
          <div style={{ fontSize: 9, fontWeight: 700, color: C.green, marginBottom: 8 }}>
            {'👁 Consultée par le client le ' + sel.vuLe}
          </div>
        ) : null}
        <DernierEnvoi
          type="FACTURE"
          id={sel.id}
          version={versionEnvoi}
          sinon={
            sel.envoyeLe && !sel.vuLe ? (
              <div style={{ fontSize: 9, fontWeight: 700, color: C.amber, marginBottom: 8 }}>
                {'📨 Envoyée le ' + sel.envoyeLe + ' · pas encore consultée'}
              </div>
            ) : null
          }
        />
        {!sel.recur && soc?.recurOn && (
          <Card style={{ marginBottom: 8 }}>
            <Bar
              icon="🔁"
              title="Programmer en facture récurrente"
              color={C.purple}
              sub="Abonnement, contrat d'entretien, loyer…"
            />
            <div style={{ padding: 13 }}>
              <div style={{ fontSize: 9.5, color: C.grey, marginBottom: 9, lineHeight: 1.5 }}>
                Crée un modèle qui regénère automatiquement cette facture à la fréquence choisie. Tu
                le retrouves dans la liste des factures.
              </div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
                {[
                  ['mensuel', 'Mensuel'],
                  ['trimestriel', 'Trimestriel'],
                  ['semestriel', 'Semestriel'],
                  ['annuel', 'Annuel'],
                ].map(([v, lb]) => (
                  <div
                    key={v}
                    onClick={() => setRecurFreq(v)}
                    style={{
                      padding: '7px 11px',
                      borderRadius: 8,
                      fontSize: 9.5,
                      fontWeight: 700,
                      cursor: 'pointer',
                      border: '1px solid ' + (recurFreq === v ? C.purple : C.border),
                      background: recurFreq === v ? C.purple : C.white,
                      color: recurFreq === v ? '#fff' : C.grey,
                    }}
                  >
                    {lb}
                  </div>
                ))}
              </div>
              <Btn
                label="🔁 Programmer cette récurrence"
                color={C.purple}
                full
                onClick={() => {
                  const tpl = {
                    ...sel,
                    id: 'REC-' + uid(),
                    num: undefined,
                    // Le serveur ne connait pas de statut « recurrent » : le
                    // modele est un brouillon qui porte une recurrence.
                    statut: 'Brouillon',
                    recur: {
                      freq: recurFreq,
                      prochaine: addMois(today(), FREQ_MOIS[recurFreq] || 1),
                      actif: true,
                    },
                    paidAmount: 0,
                    paidDate: null,
                    rappelNiveau: 0,
                    rappelLe: null,
                  };
                  setFactures((p) => [tpl, ...p]);
                  alert(
                    'Modèle récurrent créé. Retrouve-le dans la liste des factures, carte « Factures récurrentes ».',
                  );
                }}
              />
            </div>
          </Card>
        )}
        {sel.type !== 'avoir' &&
          !soldeeParAvoir &&
          (sel.statut === 'Envoyée' || sel.statut === 'Partielle') &&
          (() => {
            const niv = sel.rappelNiveau || 0;
            const prochain = Math.min(niv + 1, 3);
            const fraisReglage = Number(fraisRappel?.['rappelFrais' + prochain]);
            const fraisDef = Number.isFinite(fraisReglage)
              ? fraisReglage
              : { 1: 0, 2: 20, 3: 40 }[prochain];
            const dejaP = sel.paidAmount || 0;
            const reste = Math.max(0, ttc - creditAvoirs - dejaP);
            return (
              <Card style={{ marginBottom: 8 }}>
                <Bar
                  icon="🔔"
                  title="Rappels de paiement"
                  color={C.red}
                  sub={
                    niv > 0
                      ? (sel.rappelAutoLe && niv === 1
                          ? '1er rappel établi automatiquement'
                          : 'Dernier rappel : niveau ' + niv) +
                        (sel.rappelLe ? ' le ' + sel.rappelLe : '')
                      : 'Aucun rappel'
                  }
                />
                <div style={{ padding: 13 }}>
                  <div style={{ fontSize: 9.5, color: C.grey, marginBottom: 9, lineHeight: 1.5 }}>
                    Solde dû :{' '}
                    <b>
                      {DEVISE} {fmt(reste)}
                    </b>
                    . Le rappel A4 reprend ce solde + les frais ci-dessous, et le QR est recalculé
                    automatiquement.
                  </div>
                  <Inp
                    label={'Frais de rappel (' + DEVISE + ')'}
                    type="number"
                    value={rappelFraisInput}
                    placeholder={String(fraisDef)}
                    onChange={(e) => setRappelFraisInput(e.target.value)}
                  />
                  <div style={{ fontSize: 8.5, color: C.muted, marginTop: -4 }}>
                    {trf(
                      'Vide = {0} {1}, les frais du rappel {2} réglés dans Réglages → Envois automatiques.',
                      DEVISE,
                      fmt(fraisDef),
                      prochain,
                    )}
                  </div>
                  <div style={{ marginTop: 9 }}>
                    <Btn
                      label={
                        prochain >= 3
                          ? '⚠ Générer le dernier rappel'
                          : '🔔 Générer le rappel ' + prochain
                      }
                      color={C.red}
                      full
                      onClick={() => {
                        const fr =
                          parseFloat(
                            ((rappelFraisInput === '' ? fraisDef : rappelFraisInput) + '').replace(
                              ',',
                              '.',
                            ),
                          ) || 0;
                        setFactures((p) =>
                          p.map((f) =>
                            f.id === sel.id
                              ? { ...f, rappelNiveau: prochain, rappelLe: today(), rappelFrais: fr }
                              : f,
                          ),
                        );
                        setRappelFraisInput('');
                        setMontrerRappel(true);
                        setView('doc');
                      }}
                    />
                  </div>
                  {niv > 0 && (
                    <div style={{ marginTop: 9 }}>
                      <BoutonEnvoiServeur
                        label={'📨 Envoyer le rappel ' + niv + ' par e-mail depuis SwissTech'}
                        color={C.navy}
                        cible={cl?.email}
                        envoie={() => envoisApi.envoieRappel(sel.id)}
                        indisponible={
                          Number.isInteger(sel.id)
                            ? ''
                            : 'Enregistre la facture pour que SwissTech puisse envoyer le rappel avec son PDF.'
                        }
                        onEnvoye={() =>
                          setFactures((p) =>
                            p.map((x) => (x.id === sel.id ? { ...x, relanceLe: today() } : x)),
                          )
                        }
                      />
                    </div>
                  )}
                </div>
              </Card>
            );
          })()}
        {/* Chaque paiement à sa date — l'acompte de décembre, le solde de
            février — pour que la comptabilité le range dans la bonne année.
            L'ancien « Encaisser un acompte » notait tout à la date du jour. */}
        {encaisse &&
          sel.statut !== 'Brouillon' &&
          sel.statut !== 'Annulée' &&
          sel.type !== 'avoir' && (
            <PaiementsRecus
              facture={sel}
              ttc={auCentime(ttc - creditAvoirs)}
              paiements={paiements.get(sel.id) || []}
              // Le serveur a déjà la facture à jour : on la recharge plutôt que
              // de la lui renvoyer (un second envoi était refusé).
              onFacture={() => rechargeFactures && rechargeFactures()}
              onPaiements={rechargePaiements}
            />
          )}
        {/*
          Le brouillon s'abandonne librement. Une facture émise, le patron
          seul la supprime : la question rappelle d'abord que la loi demande
          de la garder dix ans, et qu'un avoir l'annule sans l'effacer.
        */}
        {['Envoyée', 'Partielle', 'Payée'].includes(sel.statut) &&
          sel.type !== 'avoir' &&
          !soldeeParAvoir && (
            <div style={{ marginBottom: 8 }}>
              <Btn
                label="↩ Faire un avoir"
                ghost
                color={C.amber}
                full
                onClick={() => startAvoir(sel)}
              />
            </div>
          )}
        {(sel.statut === 'Brouillon' || estPatron) && (
          <div style={{ marginBottom: 8 }}>
            <Btn
              label="🗑 Supprimer la facture"
              ghost
              danger
              color={C.red}
              full
              onClick={() => {
                // Une facture effacee emporte ses lignes et son numero, que
                // rien ne reconstitue : la question se pose avant.
                const question =
                  sel.statut === 'Brouillon'
                    ? 'Supprimer définitivement cette facture ?'
                    : 'Cette facture est déjà émise (' +
                      sel.statut +
                      ').\n\nLa loi demande de garder les factures émises 10 ans ; pour l’annuler, un avoir suffit.\n\nLa supprimer définitivement quand même ?';
                if (window.confirm(question)) {
                  setFactures((p) => p.filter((x) => x.id !== sel.id));
                  setView('liste');
                }
              }}
            />
          </div>
        )}
        {sel.statut === 'Payée' && (
          <div>
            <div
              style={{
                background: C.greenL,
                border: '1px solid ' + C.green + '30',
                borderRadius: 9,
                padding: '9px 12px',
                fontSize: 10,
                color: C.green,
                fontWeight: 700,
              }}
            >
              ✓ Payée{sel.paidDate ? ' le ' + sel.paidDate : ''}
              {sel.paidAmount ? ' · ' + DEVISE + ' ' + fmt(sel.paidAmount) : ''}
            </div>
            {/* Une facture partie sans le nom ni l'adresse de la cliente, puis
                payée : le client se choisit ici, et son adresse se
                corrige. Les montants payés ne bougent pas ; le PDF est refait. */}
            <Card style={{ marginTop: 8 }}>
              <Bar icon="👤" title={tr('Client de la facture')} color={C.navy} />
              <div style={{ padding: 12 }}>
                <select
                  value={sel.clientId ?? ''}
                  aria-label={tr('Client de la facture payée')}
                  onChange={(e) => {
                    const choisi = (clients || []).find((c) => String(c.id) === e.target.value);
                    if (choisi) {
                      setFactures((p) =>
                        p.map((x) => (x.id === sel.id ? { ...x, clientId: choisi.id } : x)),
                      );
                    }
                  }}
                  style={{
                    width: '100%',
                    border: '1px solid ' + C.border,
                    borderRadius: 9,
                    padding: '10px 11px',
                    fontSize: 11,
                    marginBottom: 6,
                  }}
                >
                  {!sel.clientId && <option value="">{tr('— Choisir le client —')}</option>}
                  {ordreDeSaisie(clients).map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.nom}
                    </option>
                  ))}
                </select>
                <ModifierClient
                  key={sel.clientId}
                  client={(clients || []).find((c) => String(c.id) === String(sel.clientId))}
                  setClients={setClients}
                />
                {/* « Nouveau client » et « Depuis mes contacts » n'ont rien à
                    faire sur une facture payée (demande du patron) : le client
                    se choisit dans la liste, son adresse se corrige. */}
                <div style={{ fontSize: 9.5, color: C.muted, marginTop: 6 }}>
                  {tr(
                    'Le nom et l’adresse s’ajoutent au PDF ; les montants payés ne changent pas.',
                  )}
                </div>
              </div>
            </Card>
            {sel.remboursement ? (
              <Card style={{ marginTop: 8 }}>
                <Bar icon="↩" title="Remboursement émis" color={C.purple} />
                <div style={{ padding: 13, fontSize: 10, lineHeight: 1.8 }}>
                  <div>
                    <b>Montant :</b> {DEVISE} {fmt(sel.remboursement.montant)}
                  </div>
                  <div>
                    <b>IBAN du client :</b> {sel.remboursement.iban || '—'}
                  </div>
                  <div>
                    <b>Motif :</b> {sel.remboursement.motif}
                  </div>
                  <div>
                    <b>Date :</b> {sel.remboursement.date}
                  </div>
                  <div style={{ marginTop: 9 }}>
                    <Btn
                      label="🖨 Imprimer la quittance"
                      sm
                      color={C.navy}
                      full
                      onClick={() => setRbPrint(true)}
                    />
                  </div>
                </div>
              </Card>
            ) : rbShow ? (
              <Card style={{ marginTop: 8, border: '2px solid ' + C.purple }}>
                <Bar
                  icon="↩"
                  title="Rembourser un trop-perçu"
                  color={C.purple}
                  sub="Ex. le client a payé deux fois la même facture"
                />
                <div style={{ padding: 13 }}>
                  <Inp
                    label={'Montant à rembourser ' + DEVISE}
                    type="text"
                    inputMode="decimal"
                    value={rbAmt}
                    onChange={(e) => setRbAmt(e.target.value.replace(',', '.'))}
                    placeholder={String(Math.round(ttc * 100) / 100)}
                  />
                  <Inp
                    label="IBAN du client (où renvoyer l'argent)"
                    value={rbIban}
                    onChange={(e) => setRbIban(e.target.value)}
                    placeholder="CH.. .... .... .... .... ."
                  />
                  <Inp label="Motif" value={rbMotif} onChange={(e) => setRbMotif(e.target.value)} />
                  <div style={{ display: 'flex', gap: 6, marginTop: 4 }}>
                    <div style={{ flex: 1 }}>
                      <Btn
                        label="✓ Enregistrer le remboursement"
                        color={C.purple}
                        full
                        onClick={() => {
                          const m = parseFloat((rbAmt + '').replace(',', '.')) || ttc;
                          setFactures((p) =>
                            p.map((f) =>
                              f.id === sel.id
                                ? {
                                    ...f,
                                    remboursement: {
                                      montant: Math.round(m * 100) / 100,
                                      iban: rbIban.trim(),
                                      motif: rbMotif.trim() || 'Remboursement',
                                      date: today(),
                                    },
                                  }
                                : f,
                            ),
                          );
                          setRbShow(false);
                          setRbAmt('');
                        }}
                      />
                    </div>
                    <Btn label="Annuler" ghost color={C.grey} onClick={() => setRbShow(false)} />
                  </div>
                </div>
              </Card>
            ) : encaisse ? (
              <div style={{ marginTop: 8 }}>
                <Btn
                  label="↩ Rembourser un trop-perçu / double paiement"
                  ghost
                  color={C.purple}
                  full
                  onClick={() => {
                    setRbShow(true);
                    setRbAmt(String(Math.round(ttc * 100) / 100));
                    setRbIban('');
                  }}
                />
              </div>
            ) : null}
          </div>
        )}
        {/* Le lien et ses boutons sont retirés (demande du patron) ; reste
            le suivi : quand le client a ouvert la facture. */}
        {!sel.recur && sel.statut !== 'Brouillon' && (
          <CarteLienClient type="facture" suiviSeul id={sel.id} clientNom={cl?.nom} />
        )}
        {rbPrint &&
          sel.remboursement &&
          (() => {
            const rb = sel.remboursement;
            return (
              <div
                style={{
                  position: 'fixed',
                  left: 0,
                  top: 0,
                  right: 0,
                  bottom: 0,
                  background: '#fff',
                  zIndex: 9999,
                  overflow: 'auto',
                }}
              >
                <div
                  className="no-print"
                  style={{
                    background: C.navy,
                    color: '#fff',
                    padding: '12px 14px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <button
                    onClick={() => setRbPrint(false)}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: '#fff',
                      fontSize: 14,
                      fontWeight: 700,
                    }}
                  >
                    ‹ Fermer
                  </button>
                  <button
                    onClick={printDoc}
                    style={{
                      background: C.green,
                      border: 'none',
                      color: '#fff',
                      borderRadius: 8,
                      padding: '8px 14px',
                      fontSize: 11,
                      fontWeight: 800,
                    }}
                  >
                    🖨 Imprimer / PDF
                  </button>
                </div>
                <div
                  style={{ padding: '24px 22px', maxWidth: 560, margin: '0 auto', color: '#111' }}
                >
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 18 }}
                  >
                    <div>
                      <div style={{ fontWeight: 800, fontSize: 13 }}>{soc?.nom || SOC.nom}</div>
                      <div style={{ fontSize: 10, color: '#555' }}>{soc?.adr || SOC.adr}</div>
                      <div style={{ fontSize: 10, color: '#555' }}>{soc?.npa || SOC.npa}</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontWeight: 800, fontSize: 13 }}>
                        Quittance de remboursement
                      </div>
                      <div style={{ fontSize: 10, color: '#555' }}>{rb.date}</div>
                    </div>
                  </div>
                  <div
                    style={{
                      background: '#f5f6f8',
                      borderRadius: 8,
                      padding: '10px 12px',
                      marginBottom: 14,
                    }}
                  >
                    <div style={{ fontWeight: 800, fontSize: 12 }}>{cl?.nom || 'Client'}</div>
                    {cl?.adr && <div style={{ fontSize: 10, color: '#555' }}>{cl.adr}</div>}
                    {cl?.npa && <div style={{ fontSize: 10, color: '#555' }}>{cl.npa}</div>}
                  </div>
                  <div style={{ fontSize: 11, lineHeight: 1.7 }}>
                    <div>
                      Concernant la facture <b>{sel.id}</b>.
                    </div>
                    <div style={{ marginTop: 6 }}>Motif : {rb.motif}</div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      background: C.purple,
                      color: '#fff',
                      borderRadius: 10,
                      padding: '14px 16px',
                      marginTop: 16,
                    }}
                  >
                    <span style={{ fontSize: 12, fontWeight: 700 }}>Montant remboursé</span>
                    <span style={{ fontSize: 20, fontWeight: 900 }}>
                      {DEVISE} {fmt(rb.montant)}
                    </span>
                  </div>
                  {rb.iban && (
                    <div style={{ fontSize: 10, color: '#555', marginTop: 12 }}>
                      Versé sur l'IBAN du client : <b>{rb.iban}</b>
                    </div>
                  )}
                  <div style={{ fontSize: 8.5, color: '#999', marginTop: 18, lineHeight: 1.5 }}>
                    Document généré par SwissTech le {rb.date}.
                  </div>
                </div>
              </div>
            );
          })()}
      </Shell>
    );
  }

  // LISTE
  const totPayee = factures
    .filter((f) => f.statut === 'Payée')
    .reduce((a, f) => a + calc(f).ttc, 0);
  // Ce qui reste du, acomptes deduits : une facture de 10'000.— deja reglee
  // pour moitie doit 5'000.—, non 10'000.—. L'ecran comptait le montant
  // entier, la comptabilite comptait le solde, et les deux chiffres se
  // contredisaient sous les yeux de la meme personne.
  const totImpaye = totalAEncaisser(factures, devis);
  const acomptesAttendus = (factures || [])
    .filter((f) => acompteEnAttente(f, devis) && aEncaisser(f, devis, factures))
    .reduce((s, f) => s + soldeApresAvoirs(f, factures), 0);
  const ql = fQ.trim().toLowerCase();
  const fAnnees = [
    ...new Set(factures.map((f) => ('' + (f.date || '')).split('.')[2]).filter(Boolean)),
  ]
    .sort()
    .reverse();
  const liste = plusRecentesEnTete(factures).filter((f) => {
    const cl = clients.find((c) => c.id === f.clientId);
    const okQ =
      !ql ||
      String(f.num ?? f.id ?? '')
        .toLowerCase()
        .includes(ql) ||
      (cl?.nom || '').toLowerCase().includes(ql);
    // « Envoyées » : ce que le client doit encore, comme la case de l'accueil.
    // Une facture payée en partie (acompte reçu) restait hors de la liste, et
    // l'accueil en annonçait sept quand la liste n'en montrait qu'une.
    const okF =
      fFilt === 'tous' ||
      (fFilt === 'Envoyée' ? aEncaisser(f, devis, factures) : f.statut === fFilt);
    const okY = fYear === 'tous' || ('' + (f.date || '')).split('.')[2] === fYear;
    // Un acompte pas encore payé n'est pas encore une facture du client :
    // il se suit depuis l'offre et arrive ici une fois payé.
    return okQ && okF && okY && !f.recur && !acompteEnAttente(f, devis);
  });
  return (
    <Shell
      active="factures"
      onNav={onNav}
      soc={soc}
      pageTitle="🧾 Factures"
      estMixte={estMixte}
      univers={univers}
      setUnivers={setUnivers}
    >
      {/* L'encaissé, c'est le chiffre d'affaires : la direction seule le voit.
          La secrétaire garde l'impayé, qu'elle relance. */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: voitLeBenefice() ? '1fr 1fr' : '1fr',
          gap: 8,
          marginBottom: 12,
        }}
      >
        {voitLeBenefice() && (
          <StatBox
            label="Encaissé (payées)"
            value={DEVISE + ' ' + fmt(totPayee)}
            color={C.green}
            icon="💰"
          />
        )}
        <StatBox
          label="Impayé en cours"
          value={DEVISE + ' ' + fmt(totImpaye)}
          color={C.amber}
          icon="⏳"
        />
      </div>
      {/* L'impayé compte les factures d'acompte envoyées à l'acceptation,
          comme le bilan et l'échéancier ; elles se suivent depuis l'offre et
          n'entrent dans la liste qu'une fois payées : le patron voit d'où
          vient l'écart. */}
      {acomptesAttendus > 0 && (
        <div style={{ fontSize: 10, color: C.muted, margin: '-6px 0 10px' }}>
          {trf(
            'dont acomptes d’offres pas encore payés : {0} (suivis dans Offres)',
            DEVISE + ' ' + fmt(acomptesAttendus),
          )}
        </div>
      )}
      <div style={{ display: 'flex', gap: 8, marginBottom: 11 }}>
        <div
          onClick={blank}
          style={{
            flex: 1,
            background: C.navy,
            borderRadius: 12,
            padding: 16,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
          }}
        >
          <span style={{ fontSize: 22, color: '#fff' }}>＋</span>
          <span style={{ fontSize: 13, fontWeight: 800, color: '#fff' }}>Nouvelle facture</span>
        </div>
        <div
          onClick={() => onNav('import')}
          style={{
            flexShrink: 0,
            background: C.white,
            border: '1px solid ' + C.navy,
            borderRadius: 12,
            padding: '16px 14px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            color: C.navy,
          }}
          title="Reprendre depuis un autre logiciel"
        >
          <span style={{ fontSize: 16 }}>📥</span>
          <span style={{ fontSize: 11, fontWeight: 800 }}>Importer</span>
        </div>
      </div>
      <input
        value={fQ}
        onChange={(e) => setFQ(e.target.value)}
        placeholder="🔎 Rechercher (n° ou client)"
        style={inpFS}
      />
      {/* La comptable reçoit les factures par e-mail, sans compte SwissTech.
          Le technicien n'y a pas accès : le chiffre d'affaires lui reste caché. */}
      {['patron', 'comptable', 'secretaire'].includes(ACCESS_ROLE) && (
        <EnvoiComptable
          factures={factures.filter((f) => !acompteEnAttente(f, devis))}
          clients={clients}
          calc={calc}
        />
      )}
      {(() => {
        if (!soc?.recurOn) return null;
        const recs = factures.filter((f) => f.recur);
        if (!recs.length) return null;
        const dues = recs.filter((f) => f.recur && f.recur.actif && dateDue(f.recur.prochaine));
        return (
          <Card style={{ marginBottom: 11 }}>
            <Bar
              icon="🔁"
              title={'Factures récurrentes — ' + recs.length}
              color={C.purple}
              sub={
                dues.length
                  ? dues.length + ' à générer maintenant'
                  : "Abonnements & contrats d'entretien"
              }
            />
            <div style={{ padding: 13 }}>
              {dues.length > 0 && (
                <Btn
                  label={
                    '⚡ Générer les ' +
                    dues.length +
                    ' facture' +
                    (dues.length > 1 ? 's' : '') +
                    ' due' +
                    (dues.length > 1 ? 's' : '')
                  }
                  color={C.purple}
                  full
                  onClick={() => genererRecurs(dues.map((d) => d.id))}
                />
              )}
              <div style={{ marginTop: dues.length ? 10 : 0 }}>
                {recs.map((t) => {
                  const cl = clients.find((c) => c.id === t.clientId);
                  const due = t.recur && dateDue(t.recur.prochaine);
                  return (
                    <div
                      key={t.id}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 7,
                        border: '1px solid ' + (due ? C.purple : C.border),
                        borderRadius: 10,
                        padding: '9px 11px',
                        marginBottom: 7,
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 10.5, fontWeight: 800 }}>
                          {cl?.nom || 'Client'} · {DEVISE} {fmt(calc(t).ttc)}
                        </div>
                        <div
                          style={{
                            fontSize: 8.5,
                            color: due ? C.purple : C.muted,
                            fontWeight: 700,
                          }}
                        >
                          {FREQ_LBL[t.recur && t.recur.freq] || 'Mensuel'} · prochaine :{' '}
                          {t.recur && t.recur.prochaine}
                          {t.recur && !t.recur.actif ? ' · en pause' : ''}
                        </div>
                      </div>
                      <div
                        onClick={() =>
                          setFactures((p) =>
                            p.map((f) =>
                              f.id === t.id
                                ? { ...f, recur: { ...f.recur, actif: !f.recur.actif } }
                                : f,
                            ),
                          )
                        }
                        style={{
                          fontSize: 8.5,
                          fontWeight: 800,
                          color: t.recur && t.recur.actif ? C.amber : C.green,
                          cursor: 'pointer',
                          padding: '5px 8px',
                          border: '1px solid ' + C.border,
                          borderRadius: 7,
                        }}
                      >
                        {t.recur && t.recur.actif ? 'Pause' : 'Activer'}
                      </div>
                      <div
                        onClick={() => genererRecurs([t.id])}
                        style={{
                          fontSize: 8.5,
                          fontWeight: 800,
                          color: '#fff',
                          background: C.purple,
                          cursor: 'pointer',
                          padding: '5px 8px',
                          borderRadius: 7,
                        }}
                      >
                        Générer
                      </div>
                      <div
                        onClick={() => setFactures((p) => p.filter((f) => f.id !== t.id))}
                        style={{ fontSize: 13, color: C.red, cursor: 'pointer' }}
                      >
                        🗑
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Card>
        );
      })()}
      {(() => {
        const retard = factures
          .filter((f) => aEncaisser(f, devis, factures) && joursRetard(f) > 0)
          .sort((a, b) => joursRetard(b) - joursRetard(a));
        // Liste filtrée (une case de l'accueil, un filtre) : le cadre des
        // retards passait devant et semblait être toute la réponse — une
        // facture en retard affichée quand l'accueil en annonçait deux.
        if (!retard.length || fFilt !== 'tous') return null;
        return (
          <Card style={{ marginBottom: 11 }}>
            <Bar
              icon="⏰"
              title={
                'À relancer — ' +
                retard.length +
                ' facture' +
                (retard.length > 1 ? 's' : '') +
                ' en retard'
              }
              color={C.amber}
            />
            <div style={{ padding: 13 }}>
              {retard.map((f) => {
                const cl = clients.find((c) => c.id === f.clientId);
                const { ttc } = calc(f);
                // Une facture payée en partie : on relance le reste, pas le
                // total (« échue · CHF 10'810 » alors que 3'000 étaient reçus).
                const reste = soldeApresAvoirs(f, factures);
                const recu = ttc - reste > 0.005 ? ttc - reste : 0;
                const dejaRecu = recu
                  ? trf(
                      'Déjà reçu : {0} {1} · reste {2} {3}',
                      DEVISE,
                      fmt(recu),
                      DEVISE,
                      fmt(reste),
                    )
                  : '';
                const jr = joursRetard(f);
                const tel = (cl?.tel || '').replace(/[^0-9]/g, '').replace(/^0/, '41');
                // Le lien suit ce qui est déjà reçu, si le client a payé en partie.
                const msg = (adresse) => {
                  const lien = (dejaRecu ? dejaRecu + '. ' : '') + adresse;
                  return (
                    'Rappel : la facture ' +
                    (f.num || f.id) +
                    ' de ' +
                    DEVISE +
                    ' ' +
                    fmt(ttc) +
                    ' est échue depuis ' +
                    jr +
                    ' jour' +
                    (jr > 1 ? 's' : '') +
                    '. Merci de procéder au paiement. ' +
                    lien
                  );
                };
                return (
                  <div
                    key={f.id}
                    style={{
                      border: '1px solid ' + C.border,
                      borderRadius: 10,
                      padding: '10px 11px',
                      marginBottom: 8,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <div>
                        <div style={{ fontSize: 10.5, fontWeight: 800 }}>
                          {f.num || f.id} · {cl?.nom || 'Client'}
                        </div>
                        <div style={{ fontSize: 8.5, color: C.amber, fontWeight: 700 }}>
                          Échue depuis {jr} jour{jr > 1 ? 's' : ''} · {DEVISE} {fmt(reste)}
                        </div>
                        {dejaRecu && <div style={{ fontSize: 8.5, color: C.grey }}>{dejaRecu}</div>}
                      </div>
                      <div
                        onClick={() => {
                          // Le lien ne changeait que la selection : la liste
                          // restait a l'ecran et rien ne s'ouvrait.
                          setSelId(f.id);
                          setView('detail');
                        }}
                        style={{ fontSize: 9, color: C.navy, fontWeight: 700, cursor: 'pointer' }}
                      >
                        Ouvrir ›
                      </div>
                    </div>
                    <RelanceParLien
                      type="facture"
                      id={f.id}
                      email={cl?.email}
                      tel={tel}
                      sujet={'Rappel facture ' + (f.num || f.id)}
                      message={msg}
                      envoiServeur={
                        Number.isInteger(f.id) ? () => envoisApi.envoieFacture(f.id) : undefined
                      }
                      onWhatsApp={() => setRelanceEnvoi(f)}
                      onRelance={() =>
                        setFactures((p) =>
                          p.map((x) => (x.id === f.id ? { ...x, relanceLe: today() } : x)),
                        )
                      }
                    />
                    {f.relanceLe && (
                      <div style={{ fontSize: 8, color: C.muted, marginTop: 5 }}>
                        Dernière relance : {f.relanceLe}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </Card>
        );
      })()}
      <div style={{ display: 'flex', gap: 6, overflowX: 'auto', marginBottom: 11 }}>
        {[
          ['tous', 'Toutes'],
          ['Envoyée', 'Envoyées'],
          ['Payée', 'Payées'],
          ['Brouillon', 'Brouillons'],
        ].map(([k, l]) => (
          <div
            key={k}
            onClick={() => setFFilt(k)}
            style={{
              flexShrink: 0,
              padding: '6px 11px',
              borderRadius: 99,
              fontSize: 9,
              fontWeight: 700,
              cursor: 'pointer',
              background: fFilt === k ? C.navy : C.white,
              color: fFilt === k ? '#fff' : C.grey,
              border: '1px solid ' + C.border,
            }}
          >
            {l}
          </div>
        ))}
      </div>
      {fAnnees.length > 1 && (
        <div style={{ display: 'flex', gap: 6, overflowX: 'auto', marginBottom: 11 }}>
          {['tous', ...fAnnees].map((y) => (
            <div
              key={y}
              onClick={() => setFYear(y)}
              style={{
                flexShrink: 0,
                padding: '6px 11px',
                borderRadius: 99,
                fontSize: 9,
                fontWeight: 700,
                cursor: 'pointer',
                border: '1px solid ' + (fYear === y ? C.teal : C.border),
                background: fYear === y ? C.teal : C.white,
                color: fYear === y ? '#fff' : C.grey,
              }}
            >
              {y === 'tous' ? '📅 Toutes' : y}
            </div>
          ))}
        </div>
      )}
      {liste.length === 0 && (
        <Card>
          <div style={{ padding: 20, textAlign: 'center', color: C.muted, fontSize: 11 }}>
            Aucune facture
          </div>
        </Card>
      )}
      {liste.map((f) => {
        const cl = clients.find((c) => c.id === f.clientId);
        const { ttc } = calc(f);
        const aEnvoyer = pasEncoreEnvoyee(f);
        const col = aEnvoyer ? C.purple : FSTATUTS[f.statut] || C.muted;
        return (
          <Card key={f.id} style={{ marginBottom: 9, borderLeft: '4px solid ' + col }}>
            <div
              onClick={() => {
                setSelId(f.id);
                setView('detail');
              }}
              style={{
                padding: '12px 14px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              <div>
                <div style={{ fontSize: 11, fontWeight: 800 }}>{f.num || f.id}</div>
                <div style={{ fontSize: 10, color: C.grey }}>{cl?.nom || '—'}</div>
                <div style={{ fontSize: 8, color: C.muted }}>
                  {f.type === 'avoir'
                    ? trf('Émise le {0}', f.date)
                    : trf('Émise le {0} · échéance {1}', f.date, dateEcheance(f))}
                </div>
                {aEncaisser(f, devis, factures) && joursRetard(f) > 0 && (
                  <div style={{ fontSize: 8, color: C.red, fontWeight: 700, marginTop: 1 }}>
                    ⚠ en retard de {joursRetard(f)} j
                  </div>
                )}
                <MentionAvoir f={f} factures={factures} />
              </div>
              <div style={{ textAlign: 'right' }}>
                <Pill label={aEnvoyer ? '✏️ à envoyer' : f.statut} color={col} size={8} />
                <div style={{ fontSize: 14, fontWeight: 900, marginTop: 5 }}>
                  {DEVISE} {fmt(ttc)}
                </div>
              </div>
            </div>
            {encaisse && aEncaisser(f, devis, factures) && (
              <div
                onClick={() => marquerPayee(f)}
                style={{
                  borderTop: '1px solid ' + C.border,
                  padding: '9px 14px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 7,
                  cursor: 'pointer',
                  color: C.green,
                  fontSize: 10,
                  fontWeight: 800,
                }}
              >
                <span
                  style={{
                    width: 16,
                    height: 16,
                    borderRadius: 5,
                    border: '2px solid ' + C.green,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 10,
                  }}
                >
                  {' '}
                </span>
                Cocher comme payée
              </div>
            )}
          </Card>
        );
      })}
      {relanceEnvoi &&
        (() => {
          const f = relanceEnvoi;
          const clR = clients.find((c) => c.id === f.clientId);
          return (
            <MenuEnvoi
              piece={f}
              nature="Facture"
              client={clR}
              soc={soc}
              relance={{ montant: DEVISE + ' ' + fmt(calc(f).ttc) }}
              onClose={() => setRelanceEnvoi(null)}
              onEnvoye={() =>
                setFactures((p) => p.map((x) => (x.id === f.id ? { ...x, relanceLe: today() } : x)))
              }
              notePartage={{ type: 'FACTURE', id: f.id }}
              lienType="facture"
              cheminPdf={Number.isInteger(f.id) ? `/factures/${f.id}/document` : undefined}
              envoiServeur={Number.isInteger(f.id) ? () => envoisApi.envoieFacture(f.id) : null}
              cibleServeur={adressesDeLaFacture(clR, f.emailsEnvoi).join(', ')}
            />
          );
        })()}
    </Shell>
  );
}

/**
 * Sous une facture créditée : l'avoir qui la solde, ou la part qu'il en
 * retranche. Sans cette mention, la facture restait « Envoyée » et le patron
 * la croyait impayée.
 */
function MentionAvoir({ f, factures }) {
  const avoirs = avoirsSur(f, factures);
  if (!avoirs.length) return null;
  const nums = avoirs.map((a) => a.num || a.id).join(', ');
  return (
    <div style={{ fontSize: 8, color: C.green, fontWeight: 700, marginTop: 2 }}>
      {regleeParAvoir(f, factures)
        ? trf('Réglée par l’avoir n° {0}', nums)
        : trf(
            'Avoir n° {0} déduit : reste {1}',
            nums,
            DEVISE + ' ' + fmt(soldeApresAvoirs(f, factures)),
          )}
    </div>
  );
}
